var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _path21, _path22, _path23, _g2, _path24, _path25, _path26, _path27, _path28, _circle, _circle2, _path29, _circle3, _path30, _circle4, _path31, _rect, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB2BProject3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2156.8 1423.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#bdd0fb;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:#91b3fa;}.cls-5{fill:#2b69b3;}.cls-6,.cls-8{fill:#fff;}.cls-12,.cls-6{opacity:0.6;}.cls-7{fill:url(#linear-gradient-3);}.cls-9{fill:#18174a;}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:#7d97f4;}.cls-13{opacity:0.38;}.cls-14{fill:url(#linear-gradient-5);}.cls-15{fill:url(#linear-gradient-6);}.cls-16{fill:url(#linear-gradient-7);}.cls-17{fill:url(#linear-gradient-8);}.cls-18{fill:url(#linear-gradient-9);}.cls-19{fill:url(#linear-gradient-10);}.cls-20{fill:url(#linear-gradient-11);}.cls-21{fill:url(#linear-gradient-12);}.cls-22{fill:url(#linear-gradient-13);}.cls-23{fill:url(#linear-gradient-14);}.cls-24{fill:url(#linear-gradient-15);}.cls-25{fill:url(#linear-gradient-16);}.cls-26{fill:url(#linear-gradient-17);}.cls-27{fill:url(#linear-gradient-18);}.cls-28{fill:url(#linear-gradient-19);}.cls-29{fill:url(#linear-gradient-20);}.cls-30{fill:url(#linear-gradient-21);}.cls-31{fill:url(#linear-gradient-22);}.cls-32{fill:url(#linear-gradient-23);}.cls-33{fill:url(#linear-gradient-24);}.cls-34{fill:url(#linear-gradient-25);}.cls-35{fill:url(#linear-gradient-26);}.cls-36{fill:url(#linear-gradient-27);}.cls-37{fill:url(#linear-gradient-28);}.cls-38{fill:url(#linear-gradient-29);}.cls-39{fill:url(#linear-gradient-30);}.cls-40{fill:url(#linear-gradient-31);}.cls-41{fill:url(#linear-gradient-32);}.cls-42{fill:url(#linear-gradient-33);}.cls-43{fill:url(#linear-gradient-34);}.cls-44{fill:url(#linear-gradient-35);}.cls-45{fill:url(#linear-gradient-36);}.cls-46{fill:url(#linear-gradient-37);}.cls-47{fill:url(#linear-gradient-38);}.cls-48{fill:url(#linear-gradient-39);}.cls-49{fill:url(#linear-gradient-40);}.cls-50{fill:url(#linear-gradient-41);}.cls-51{fill:url(#linear-gradient-42);}.cls-52{fill:url(#linear-gradient-43);}.cls-53{fill:url(#linear-gradient-44);}.cls-54{fill:url(#linear-gradient-45);}.cls-55{fill:url(#linear-gradient-46);}.cls-56{fill:url(#linear-gradient-47);}.cls-57{fill:url(#linear-gradient-48);}.cls-58{fill:url(#linear-gradient-49);}.cls-59{fill:url(#linear-gradient-50);}.cls-60{fill:url(#linear-gradient-51);}.cls-61{fill:url(#linear-gradient-52);}.cls-62{fill:url(#linear-gradient-53);}.cls-63{fill:url(#linear-gradient-54);}.cls-64{fill:url(#linear-gradient-55);}.cls-65{fill:url(#linear-gradient-56);}.cls-66{fill:url(#linear-gradient-57);}.cls-67{fill:url(#linear-gradient-58);}.cls-68{fill:url(#linear-gradient-59);}.cls-69{fill:url(#linear-gradient-60);}.cls-70{fill:url(#linear-gradient-61);}.cls-71{fill:url(#linear-gradient-62);}.cls-72{fill:url(#linear-gradient-63);}.cls-73{fill:url(#linear-gradient-64);}.cls-74{fill:url(#linear-gradient-65);}.cls-75{fill:url(#linear-gradient-66);}.cls-76{fill:url(#linear-gradient-67);}.cls-77{fill:url(#linear-gradient-68);}.cls-78{fill:url(#linear-gradient-69);}.cls-79{fill:url(#linear-gradient-70);}.cls-80{fill:url(#linear-gradient-71);}.cls-81{fill:url(#linear-gradient-72);}.cls-82{fill:url(#linear-gradient-73);}.cls-83{fill:url(#linear-gradient-74);}.cls-84{fill:url(#linear-gradient-75);}.cls-85{fill:url(#linear-gradient-76);}.cls-86{fill:url(#linear-gradient-77);}.cls-87{fill:url(#linear-gradient-78);}.cls-88{fill:url(#linear-gradient-79);}.cls-89{fill:url(#linear-gradient-80);}.cls-90{fill:url(#linear-gradient-81);}.cls-91{fill:url(#linear-gradient-82);}.cls-92{fill:url(#linear-gradient-83);}.cls-93{fill:url(#linear-gradient-84);}.cls-94{fill:url(#linear-gradient-85);}.cls-95{fill:url(#linear-gradient-86);}.cls-96{fill:url(#linear-gradient-87);}.cls-97{fill:url(#linear-gradient-88);}.cls-98{fill:url(#linear-gradient-89);}.cls-99{fill:url(#linear-gradient-90);}.cls-100{fill:url(#linear-gradient-91);}.cls-101{fill:url(#linear-gradient-92);}.cls-102{fill:url(#linear-gradient-93);}.cls-103{fill:url(#linear-gradient-94);}.cls-104{fill:url(#linear-gradient-95);}.cls-105{fill:url(#linear-gradient-96);}.cls-106{fill:url(#linear-gradient-97);}.cls-107{fill:url(#linear-gradient-98);}.cls-108{fill:url(#linear-gradient-99);}.cls-109{fill:url(#linear-gradient-100);}.cls-110{fill:url(#linear-gradient-101);}.cls-111{fill:url(#linear-gradient-102);}.cls-112{fill:url(#linear-gradient-103);}.cls-113{fill:url(#linear-gradient-104);}.cls-114{fill:url(#linear-gradient-105);}.cls-115{fill:url(#linear-gradient-106);}.cls-116{fill:url(#linear-gradient-107);}.cls-117{fill:url(#linear-gradient-108);}.cls-118{fill:url(#linear-gradient-109);}.cls-119{fill:url(#linear-gradient-110);}.cls-120{fill:url(#linear-gradient-111);}.cls-121{fill:url(#linear-gradient-112);}.cls-122{fill:url(#linear-gradient-113);}.cls-123{fill:url(#linear-gradient-114);}.cls-124{fill:url(#linear-gradient-115);}.cls-125{fill:url(#linear-gradient-116);}.cls-126{fill:url(#linear-gradient-117);}.cls-127{fill:url(#linear-gradient-118);}.cls-128{fill:url(#linear-gradient-119);}.cls-129{fill:url(#linear-gradient-120);}.cls-130{fill:url(#linear-gradient-121);}.cls-131{fill:url(#linear-gradient-122);}.cls-132{fill:url(#linear-gradient-123);}.cls-133{fill:url(#linear-gradient-124);}.cls-134{fill:url(#linear-gradient-125);}.cls-135{fill:url(#linear-gradient-126);}.cls-136{fill:url(#linear-gradient-127);}.cls-137{fill:url(#linear-gradient-128);}.cls-138{fill:url(#linear-gradient-129);}.cls-139{fill:url(#linear-gradient-130);}.cls-140{fill:url(#linear-gradient-131);}.cls-141{fill:url(#linear-gradient-132);}.cls-142{fill:url(#linear-gradient-133);}.cls-143{fill:url(#linear-gradient-134);}.cls-144{fill:url(#linear-gradient-135);}.cls-145{fill:url(#linear-gradient-136);}.cls-146{fill:url(#linear-gradient-137);}.cls-147{fill:url(#linear-gradient-138);}.cls-148{fill:url(#linear-gradient-139);}.cls-149{fill:url(#linear-gradient-140);}.cls-150{fill:url(#linear-gradient-141);}.cls-151{fill:url(#linear-gradient-142);}.cls-152{fill:url(#linear-gradient-143);}.cls-153{fill:url(#linear-gradient-144);}.cls-154{fill:url(#linear-gradient-145);}.cls-155{fill:url(#linear-gradient-146);}.cls-156{fill:url(#linear-gradient-147);}.cls-157{fill:url(#linear-gradient-148);}.cls-158{fill:url(#linear-gradient-149);}.cls-159{fill:url(#linear-gradient-150);}.cls-160{fill:url(#linear-gradient-151);}.cls-161{fill:url(#linear-gradient-152);}.cls-162{fill:url(#linear-gradient-153);}.cls-163{fill:url(#linear-gradient-154);}.cls-164{fill:url(#linear-gradient-155);}.cls-165{fill:url(#linear-gradient-156);}.cls-166{fill:url(#linear-gradient-157);}.cls-167{fill:url(#linear-gradient-158);}.cls-168{fill:url(#linear-gradient-159);}.cls-169{fill:url(#linear-gradient-160);}.cls-170{fill:url(#linear-gradient-161);}.cls-171{fill:url(#linear-gradient-162);}.cls-172{fill:url(#linear-gradient-163);}.cls-173{fill:url(#linear-gradient-164);}.cls-174{fill:url(#linear-gradient-165);}.cls-175{fill:url(#linear-gradient-166);}.cls-176{fill:url(#linear-gradient-167);}.cls-177{fill:url(#linear-gradient-168);}.cls-178{fill:url(#linear-gradient-169);}.cls-179{fill:url(#linear-gradient-170);}.cls-180{fill:url(#linear-gradient-171);}.cls-181{fill:url(#linear-gradient-172);}.cls-182{fill:url(#linear-gradient-173);}.cls-183{fill:url(#linear-gradient-174);}.cls-184{fill:url(#linear-gradient-175);}.cls-185{fill:url(#linear-gradient-176);}.cls-186{fill:url(#linear-gradient-177);}.cls-187{fill:url(#linear-gradient-178);}.cls-188{fill:url(#linear-gradient-179);}.cls-189{fill:url(#linear-gradient-180);}.cls-190{fill:url(#linear-gradient-181);}.cls-191{fill:url(#linear-gradient-182);}.cls-192{fill:url(#linear-gradient-183);}.cls-193{fill:url(#linear-gradient-184);}.cls-194{fill:url(#linear-gradient-185);}.cls-195{fill:url(#linear-gradient-186);}.cls-196{fill:url(#linear-gradient-187);}.cls-197{fill:url(#linear-gradient-188);}.cls-198{fill:url(#linear-gradient-189);}.cls-199{fill:url(#linear-gradient-190);}.cls-200{fill:url(#linear-gradient-191);}.cls-201{fill:url(#linear-gradient-192);}.cls-202{fill:url(#linear-gradient-193);}.cls-203{fill:url(#linear-gradient-194);}.cls-204{fill:url(#linear-gradient-195);}.cls-205{fill:url(#linear-gradient-196);}.cls-206{fill:url(#linear-gradient-197);}.cls-207{fill:url(#linear-gradient-198);}.cls-208{fill:url(#linear-gradient-199);}.cls-209{fill:url(#linear-gradient-200);}.cls-210{fill:url(#linear-gradient-201);}.cls-211{fill:url(#linear-gradient-202);}.cls-212{fill:url(#linear-gradient-203);}.cls-213{fill:url(#linear-gradient-204);}.cls-214{fill:url(#linear-gradient-205);}.cls-215{fill:url(#linear-gradient-206);}.cls-216{fill:url(#linear-gradient-207);}.cls-217{fill:url(#linear-gradient-208);}.cls-218{fill:url(#linear-gradient-209);}.cls-219{fill:url(#linear-gradient-210);}.cls-220{fill:url(#linear-gradient-211);}.cls-221{fill:url(#linear-gradient-212);}.cls-222{fill:url(#linear-gradient-213);}.cls-223{fill:url(#linear-gradient-214);}.cls-224{fill:url(#linear-gradient-215);}.cls-225{fill:url(#linear-gradient-216);}.cls-226{fill:url(#linear-gradient-217);}.cls-227{fill:url(#linear-gradient-218);}.cls-228{fill:url(#linear-gradient-219);}.cls-229{fill:url(#linear-gradient-220);}.cls-230{fill:url(#linear-gradient-221);}.cls-231{fill:url(#linear-gradient-222);}.cls-232{fill:url(#linear-gradient-223);}.cls-233{fill:url(#linear-gradient-224);}.cls-234{fill:url(#linear-gradient-225);}.cls-235{fill:url(#linear-gradient-226);}.cls-236{fill:url(#linear-gradient-227);}.cls-237{fill:url(#linear-gradient-228);}.cls-238{fill:url(#linear-gradient-229);}.cls-239{fill:url(#linear-gradient-230);}.cls-240{fill:url(#linear-gradient-231);}.cls-241{fill:url(#linear-gradient-232);}.cls-242{fill:url(#linear-gradient-233);}.cls-243{fill:url(#linear-gradient-234);}.cls-244{fill:url(#linear-gradient-235);}.cls-245{fill:url(#linear-gradient-236);}.cls-246{fill:#faf3fe;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 112.6,
    y1: 707.88,
    x2: 2156.8,
    y2: 707.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 154.76,
    y1: 732.88,
    x2: 503.15,
    y2: 732.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 321.07,
    y1: 1161.16,
    x2: 885.65,
    y2: 1161.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 626.85,
    y1: 2104.7,
    x2: 1578.85,
    y2: -839.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1507.93,
    y1: 1260.43,
    x2: 1793.4,
    y2: 1260.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -911.26,
    y1: 3171.16,
    x2: -947.08,
    y2: 3555.41,
    gradientTransform: "translate(-1740.81 2117.97) rotate(-135)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -942.18,
    y1: 3698.76,
    x2: -991.02,
    y2: 4222.65,
    gradientTransform: "translate(-1740.81 2117.97) rotate(-135)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1.85,
    y1: 3698.76,
    x2: -50.69,
    y2: 4222.65,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, -1106.1, 2752.68)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1598.97,
    y1: 406.17,
    x2: 2055.35,
    y2: 406.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1602.6,
    y1: 453.91,
    x2: 2047.41,
    y2: 453.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1767.78,
    y1: 631.29,
    x2: 2051.45,
    y2: 631.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1770.04,
    y1: 660.96,
    x2: 2046.52,
    y2: 660.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -4105.75,
    y1: 832.85,
    x2: -4037.75,
    y2: 987.58,
    gradientTransform: "matrix(-1, 0, 0, 1, -3429.9, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a22b25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0423c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -3085.35,
    y1: -1019.48,
    x2: -3160.68,
    y2: -792.81,
    gradientTransform: "matrix(-1, 0, 0, 1, -3429.9, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -4027.14,
    y1: 1493.75,
    x2: -3982.22,
    y2: 968.76,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -3205.54,
    y1: -1059.43,
    x2: -3280.88,
    y2: -832.76,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -3936.78,
    y1: 1501.57,
    x2: -3891.85,
    y2: 976.43,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 603.1,
    y1: 859.42,
    x2: 584.43,
    y2: 936.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 627.8,
    y1: 918.77,
    x2: 577.8,
    y2: 978.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -1999.02,
    y1: 4207.01,
    x2: -2037.02,
    y2: 4144.34,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -1985.27,
    y1: 4198.68,
    x2: -2023.27,
    y2: 4136.01,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -4119.19,
    y1: 838.76,
    x2: -4051.19,
    y2: 993.49,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 692.79,
    y1: 658.12,
    x2: 720.12,
    y2: 816.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 5341.96,
    y1: 1354.34,
    x2: 5361.23,
    y2: 1354.34,
    gradientTransform: "matrix(-1, 0, 0, 1, 7182.74, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 5433.24,
    y1: 1355.97,
    x2: 5456.25,
    y2: 1355.97,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1852.45,
    y1: 991.79,
    x2: 1906.45,
    y2: 1066.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1855.61,
    y1: 1003.23,
    x2: 1780.61,
    y2: 683.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 5402.35,
    y1: 1142.99,
    x2: 5455.49,
    y2: 1142.99,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 7241.35,
    y1: 1773.4,
    x2: 7229.35,
    y2: 1828.73,
    gradientTransform: "matrix(-0.99, -0.13, -0.13, 0.99, 9239.18, -175.07)",
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 7223.31,
    y1: 1769.49,
    x2: 7211.31,
    y2: 1824.82,
    gradientTransform: "matrix(-0.99, -0.13, -0.13, 0.99, 9239.18, -175.07)",
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 5440.1,
    y1: 1152.73,
    x2: 5420.54,
    y2: 1297.39,
    gradientTransform: "matrix(-1, 0, 0, 1, 7182.74, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 756.97,
    y1: 1223.71,
    x2: 1022.05,
    y2: 1223.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 760.48,
    y1: 1237.29,
    x2: 993.92,
    y2: 1237.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 700.8,
    y1: 1307.05,
    x2: 1040.82,
    y2: 1307.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 708,
    y1: 1268.79,
    x2: 1036.95,
    y2: 1268.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1361.31,
    y1: 1341.14,
    x2: 1365.86,
    y2: 1341.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1356.04,
    y1: 1332.6,
    x2: 1360.71,
    y2: 1332.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1350.51,
    y1: 1324.24,
    x2: 1355.3,
    y2: 1324.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1344.72,
    y1: 1316.04,
    x2: 1349.63,
    y2: 1316.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1338.68,
    y1: 1308.03,
    x2: 1343.7,
    y2: 1308.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1332.4,
    y1: 1300.2,
    x2: 1337.54,
    y2: 1300.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1325.89,
    y1: 1292.57,
    x2: 1331.14,
    y2: 1292.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1319.16,
    y1: 1285.12,
    x2: 1324.52,
    y2: 1285.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1312.22,
    y1: 1277.88,
    x2: 1317.68,
    y2: 1277.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1305.07,
    y1: 1270.84,
    x2: 1310.63,
    y2: 1270.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1297.73,
    y1: 1264,
    x2: 1303.39,
    y2: 1264,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1290.2,
    y1: 1257.36,
    x2: 1295.96,
    y2: 1257.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1282.49,
    y1: 1250.93,
    x2: 1288.35,
    y2: 1250.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1274.62,
    y1: 1244.71,
    x2: 1280.57,
    y2: 1244.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1266.59,
    y1: 1238.7,
    x2: 1272.62,
    y2: 1238.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1258.4,
    y1: 1232.89,
    x2: 1264.52,
    y2: 1232.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1250.08,
    y1: 1227.3,
    x2: 1256.28,
    y2: 1227.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1241.61,
    y1: 1221.91,
    x2: 1247.9,
    y2: 1221.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1233.02,
    y1: 1216.73,
    x2: 1239.38,
    y2: 1216.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1224.3,
    y1: 1211.76,
    x2: 1230.75,
    y2: 1211.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1215.47,
    y1: 1207,
    x2: 1221.99,
    y2: 1207,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1206.53,
    y1: 1202.44,
    x2: 1213.13,
    y2: 1202.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1197.49,
    y1: 1198.09,
    x2: 1204.16,
    y2: 1198.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1188.36,
    y1: 1193.95,
    x2: 1195.09,
    y2: 1193.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1179.14,
    y1: 1190.01,
    x2: 1185.94,
    y2: 1190.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1169.84,
    y1: 1186.28,
    x2: 1176.69,
    y2: 1186.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 1160.46,
    y1: 1182.75,
    x2: 1167.35,
    y2: 1182.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1151,
    y1: 1179.43,
    x2: 1157.94,
    y2: 1179.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 1141.48,
    y1: 1176.3,
    x2: 1148.46,
    y2: 1176.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1131.9,
    y1: 1173.39,
    x2: 1138.92,
    y2: 1173.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1122.25,
    y1: 1170.67,
    x2: 1129.32,
    y2: 1170.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1112.55,
    y1: 1168.16,
    x2: 1119.66,
    y2: 1168.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 1102.8,
    y1: 1165.85,
    x2: 1109.95,
    y2: 1165.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 1093.01,
    y1: 1163.75,
    x2: 1100.19,
    y2: 1163.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 1083.17,
    y1: 1161.85,
    x2: 1090.39,
    y2: 1161.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 1073.3,
    y1: 1160.16,
    x2: 1080.55,
    y2: 1160.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 1063.4,
    y1: 1158.67,
    x2: 1070.68,
    y2: 1158.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 1053.46,
    y1: 1157.39,
    x2: 1060.78,
    y2: 1157.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 1043.5,
    y1: 1156.32,
    x2: 1050.84,
    y2: 1156.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 1033.53,
    y1: 1155.45,
    x2: 1040.9,
    y2: 1155.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 1023.54,
    y1: 1154.76,
    x2: 1030.94,
    y2: 1154.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 1013.54,
    y1: 1154.26,
    x2: 1020.96,
    y2: 1154.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 1003.53,
    y1: 1153.93,
    x2: 1010.98,
    y2: 1153.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 993.52,
    y1: 1153.78,
    x2: 1000.99,
    y2: 1153.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 983.51,
    y1: 1153.81,
    x2: 991.01,
    y2: 1153.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 973.5,
    y1: 1154,
    x2: 981.02,
    y2: 1154,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 963.5,
    y1: 1154.36,
    x2: 971.04,
    y2: 1154.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 953.5,
    y1: 1154.88,
    x2: 961.06,
    y2: 1154.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 943.52,
    y1: 1155.56,
    x2: 951.1,
    y2: 1155.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 933.54,
    y1: 1156.4,
    x2: 941.14,
    y2: 1156.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 923.58,
    y1: 1157.38,
    x2: 931.2,
    y2: 1157.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 913.64,
    y1: 1158.52,
    x2: 921.27,
    y2: 1158.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 903.71,
    y1: 1159.8,
    x2: 911.37,
    y2: 1159.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 893.81,
    y1: 1161.22,
    x2: 901.48,
    y2: 1161.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 883.93,
    y1: 1162.78,
    x2: 891.6,
    y2: 1162.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 874.08,
    y1: 1164.48,
    x2: 881.75,
    y2: 1164.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 864.24,
    y1: 1166.3,
    x2: 871.91,
    y2: 1166.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 854.44,
    y1: 1168.25,
    x2: 862.11,
    y2: 1168.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 844.65,
    y1: 1170.32,
    x2: 852.32,
    y2: 1170.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 834.9,
    y1: 1172.51,
    x2: 842.57,
    y2: 1172.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 825.17,
    y1: 1174.82,
    x2: 832.84,
    y2: 1174.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 815.47,
    y1: 1177.23,
    x2: 823.14,
    y2: 1177.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 805.8,
    y1: 1179.76,
    x2: 813.46,
    y2: 1179.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 796.15,
    y1: 1182.39,
    x2: 803.82,
    y2: 1182.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 786.53,
    y1: 1185.12,
    x2: 794.2,
    y2: 1185.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 776.94,
    y1: 1187.96,
    x2: 784.6,
    y2: 1187.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 767.37,
    y1: 1190.89,
    x2: 775.04,
    y2: 1190.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 757.83,
    y1: 1193.91,
    x2: 765.5,
    y2: 1193.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 748.33,
    y1: 1197.02,
    x2: 755.99,
    y2: 1197.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 738.85,
    y1: 1200.22,
    x2: 746.51,
    y2: 1200.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 729.41,
    y1: 1203.5,
    x2: 737.07,
    y2: 1203.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 719.99,
    y1: 1206.86,
    x2: 727.65,
    y2: 1206.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 710.6,
    y1: 1210.3,
    x2: 718.26,
    y2: 1210.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 701.23,
    y1: 1213.81,
    x2: 708.89,
    y2: 1213.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 691.89,
    y1: 1217.4,
    x2: 699.55,
    y2: 1217.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 682.58,
    y1: 1221.06,
    x2: 690.24,
    y2: 1221.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 673.3,
    y1: 1224.78,
    x2: 680.96,
    y2: 1224.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 664.04,
    y1: 1228.57,
    x2: 671.7,
    y2: 1228.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 654.81,
    y1: 1232.41,
    x2: 662.46,
    y2: 1232.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 645.59,
    y1: 1236.29,
    x2: 653.25,
    y2: 1236.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 636.38,
    y1: 1240.2,
    x2: 644.04,
    y2: 1240.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 627.18,
    y1: 1244.12,
    x2: 634.85,
    y2: 1244.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 617.98,
    y1: 1248.06,
    x2: 625.66,
    y2: 1248.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 608.78,
    y1: 1251.98,
    x2: 616.47,
    y2: 1251.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 599.58,
    y1: 1255.9,
    x2: 607.27,
    y2: 1255.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 590.36,
    y1: 1259.79,
    x2: 598.07,
    y2: 1259.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 581.12,
    y1: 1263.64,
    x2: 588.84,
    y2: 1263.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 571.87,
    y1: 1267.45,
    x2: 579.61,
    y2: 1267.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 562.59,
    y1: 1271.2,
    x2: 570.35,
    y2: 1271.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 553.29,
    y1: 1274.89,
    x2: 561.06,
    y2: 1274.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 543.95,
    y1: 1278.5,
    x2: 551.74,
    y2: 1278.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 534.58,
    y1: 1282.01,
    x2: 542.39,
    y2: 1282.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 525.17,
    y1: 1285.43,
    x2: 533,
    y2: 1285.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 515.73,
    y1: 1288.73,
    x2: 523.57,
    y2: 1288.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 506.24,
    y1: 1291.9,
    x2: 514.09,
    y2: 1291.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 496.71,
    y1: 1294.94,
    x2: 504.57,
    y2: 1294.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 487.13,
    y1: 1297.82,
    x2: 495,
    y2: 1297.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 477.5,
    y1: 1300.54,
    x2: 485.38,
    y2: 1300.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 467.82,
    y1: 1303.08,
    x2: 475.71,
    y2: 1303.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 458.09,
    y1: 1305.42,
    x2: 465.99,
    y2: 1305.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 448.33,
    y1: 1307.55,
    x2: 456.23,
    y2: 1307.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 438.51,
    y1: 1309.46,
    x2: 446.42,
    y2: 1309.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 428.64,
    y1: 1311.14,
    x2: 436.57,
    y2: 1311.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 418.74,
    y1: 1312.56,
    x2: 426.67,
    y2: 1312.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 408.81,
    y1: 1313.71,
    x2: 416.74,
    y2: 1313.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 398.85,
    y1: 1314.59,
    x2: 406.78,
    y2: 1314.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 388.87,
    y1: 1315.18,
    x2: 396.8,
    y2: 1315.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 378.87,
    y1: 1315.46,
    x2: 386.8,
    y2: 1315.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 368.88,
    y1: 1315.43,
    x2: 376.8,
    y2: 1315.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 358.89,
    y1: 1315.08,
    x2: 366.8,
    y2: 1315.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 348.92,
    y1: 1314.35,
    x2: 356.82,
    y2: 1314.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 338.99,
    y1: 1313.25,
    x2: 346.88,
    y2: 1313.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 329.12,
    y1: 1311.78,
    x2: 336.97,
    y2: 1311.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 319.3,
    y1: 1309.94,
    x2: 327.13,
    y2: 1309.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 309.56,
    y1: 1307.74,
    x2: 317.36,
    y2: 1307.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 299.91,
    y1: 1305.18,
    x2: 307.68,
    y2: 1305.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 290.36,
    y1: 1302.29,
    x2: 298.09,
    y2: 1302.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 280.92,
    y1: 1299.06,
    x2: 288.6,
    y2: 1299.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 271.6,
    y1: 1295.5,
    x2: 279.24,
    y2: 1295.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 262.4,
    y1: 1291.62,
    x2: 270,
    y2: 1291.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 253.34,
    y1: 1287.44,
    x2: 260.89,
    y2: 1287.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 244.43,
    y1: 1282.96,
    x2: 251.92,
    y2: 1282.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 235.68,
    y1: 1278.19,
    x2: 243.11,
    y2: 1278.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 227.08,
    y1: 1273.14,
    x2: 234.46,
    y2: 1273.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 218.65,
    y1: 1267.81,
    x2: 225.97,
    y2: 1267.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 210.38,
    y1: 1262.22,
    x2: 217.65,
    y2: 1262.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 202.3,
    y1: 1256.36,
    x2: 209.5,
    y2: 1256.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 194.41,
    y1: 1250.27,
    x2: 201.54,
    y2: 1250.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 186.71,
    y1: 1243.93,
    x2: 193.78,
    y2: 1243.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 179.2,
    y1: 1237.35,
    x2: 186.21,
    y2: 1237.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 171.91,
    y1: 1230.55,
    x2: 178.84,
    y2: 1230.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 164.82,
    y1: 1223.53,
    x2: 171.68,
    y2: 1223.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 157.95,
    y1: 1216.3,
    x2: 164.74,
    y2: 1216.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 151.31,
    y1: 1208.86,
    x2: 158.02,
    y2: 1208.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 144.89,
    y1: 1201.22,
    x2: 151.53,
    y2: 1201.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 138.71,
    y1: 1193.39,
    x2: 145.27,
    y2: 1193.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 132.78,
    y1: 1185.38,
    x2: 139.26,
    y2: 1185.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 127.09,
    y1: 1177.18,
    x2: 133.49,
    y2: 1177.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 121.66,
    y1: 1168.81,
    x2: 127.97,
    y2: 1168.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 116.5,
    y1: 1160.27,
    x2: 122.72,
    y2: 1160.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 111.62,
    y1: 1151.57,
    x2: 117.74,
    y2: 1151.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 107.01,
    y1: 1142.72,
    x2: 113.03,
    y2: 1142.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 102.7,
    y1: 1133.73,
    x2: 108.61,
    y2: 1133.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 98.68,
    y1: 1124.59,
    x2: 104.48,
    y2: 1124.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 94.97,
    y1: 1115.33,
    x2: 100.66,
    y2: 1115.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 91.58,
    y1: 1105.95,
    x2: 97.14,
    y2: 1105.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 88.5,
    y1: 1096.46,
    x2: 93.95,
    y2: 1096.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 85.76,
    y1: 1086.86,
    x2: 91.09,
    y2: 1086.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 83.35,
    y1: 1077.17,
    x2: 88.56,
    y2: 1077.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 81.29,
    y1: 1067.4,
    x2: 86.37,
    y2: 1067.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 79.59,
    y1: 1057.55,
    x2: 84.54,
    y2: 1057.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 78.24,
    y1: 1047.65,
    x2: 83.07,
    y2: 1047.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 77.27,
    y1: 1037.71,
    x2: 81.96,
    y2: 1037.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 76.67,
    y1: 1027.73,
    x2: 81.23,
    y2: 1027.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 76.45,
    y1: 1017.74,
    x2: 80.87,
    y2: 1017.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 76.53,
    y1: 1007.74,
    x2: 80.98,
    y2: 1007.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 76.96,
    y1: 997.75,
    x2: 81.51,
    y2: 997.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 77.77,
    y1: 987.79,
    x2: 82.42,
    y2: 987.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 78.96,
    y1: 977.87,
    x2: 83.7,
    y2: 977.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 80.51,
    y1: 968,
    x2: 85.34,
    y2: 968,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 82.43,
    y1: 958.19,
    x2: 87.35,
    y2: 958.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 84.7,
    y1: 948.47,
    x2: 89.71,
    y2: 948.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 87.32,
    y1: 938.83,
    x2: 92.41,
    y2: 938.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 90.28,
    y1: 929.29,
    x2: 95.45,
    y2: 929.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 93.57,
    y1: 919.86,
    x2: 98.81,
    y2: 919.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 97.18,
    y1: 910.55,
    x2: 102.49,
    y2: 910.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 101.1,
    y1: 901.36,
    x2: 106.49,
    y2: 901.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 105.32,
    y1: 892.32,
    x2: 110.78,
    y2: 892.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 109.84,
    y1: 883.42,
    x2: 115.37,
    y2: 883.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 114.65,
    y1: 874.67,
    x2: 120.24,
    y2: 874.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 119.73,
    y1: 866.08,
    x2: 125.38,
    y2: 866.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 125.09,
    y1: 857.65,
    x2: 130.8,
    y2: 857.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 130.7,
    y1: 849.39,
    x2: 136.47,
    y2: 849.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 136.57,
    y1: 841.32,
    x2: 142.4,
    y2: 841.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 142.7,
    y1: 833.43,
    x2: 148.56,
    y2: 833.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 149.07,
    y1: 825.73,
    x2: 154.96,
    y2: 825.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 155.66,
    y1: 818.24,
    x2: 161.59,
    y2: 818.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 162.49,
    y1: 810.94,
    x2: 168.44,
    y2: 810.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 169.53,
    y1: 803.86,
    x2: 175.52,
    y2: 803.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 176.79,
    y1: 796.99,
    x2: 182.8,
    y2: 796.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 184.25,
    y1: 790.35,
    x2: 190.29,
    y2: 790.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 191.91,
    y1: 783.94,
    x2: 197.97,
    y2: 783.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 199.77,
    y1: 777.76,
    x2: 205.85,
    y2: 777.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 207.81,
    y1: 771.83,
    x2: 213.91,
    y2: 771.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 216.03,
    y1: 766.15,
    x2: 222.15,
    y2: 766.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 224.43,
    y1: 760.74,
    x2: 230.56,
    y2: 760.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 232.99,
    y1: 755.59,
    x2: 239.14,
    y2: 755.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 241.72,
    y1: 750.71,
    x2: 247.88,
    y2: 750.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 250.61,
    y1: 746.12,
    x2: 256.78,
    y2: 746.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 259.63,
    y1: 741.82,
    x2: 265.81,
    y2: 741.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 268.8,
    y1: 737.83,
    x2: 274.97,
    y2: 737.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 278.09,
    y1: 734.14,
    x2: 284.27,
    y2: 734.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 287.5,
    y1: 730.78,
    x2: 293.68,
    y2: 730.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 297.03,
    y1: 727.74,
    x2: 303.21,
    y2: 727.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 306.66,
    y1: 725.03,
    x2: 312.83,
    y2: 725.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 316.38,
    y1: 722.67,
    x2: 322.54,
    y2: 722.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 326.19,
    y1: 720.66,
    x2: 332.33,
    y2: 720.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 336.06,
    y1: 719.01,
    x2: 342.18,
    y2: 719.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 345.99,
    y1: 717.73,
    x2: 352.09,
    y2: 717.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 355.96,
    y1: 716.82,
    x2: 362.03,
    y2: 716.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 365.96,
    y1: 716.29,
    x2: 372,
    y2: 716.29,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2099,776.59c-35.44-38.86-77.35-76.75-88.28-129.51-18.91-91.28,62-169.12,88.43-258.28,18.31-61.65,8.86-131.84-25-185.63s-91.38-90.09-152.19-96C1817.34,97,1715,171.63,1611.9,150c-82.51-17.3-147.72-93.62-231.48-101.8-98.57-9.62-180.35,76.5-274.47,108.92-112.58,38.78-234.64-1.75-345.33-46.23S533.47,16.81,416.8,38.1C286.92,61.8,178,181.57,160.66,319.84c-17.21,137,127.16,247,4.27,411.56-38.41,51.42-64,123-47,186,16.5,61.24,86.7,100,87.21,163.66.4,50.27-44.38,90.27-48,140.4-3.1,43,26.14,82.81,62.07,103.2s77.63,25.38,118.16,30l-11.95,13.59c204.19,19.4,409.64,15.08,614.6,10.75l969.69-20.51c33.22-.7,67.25-1.57,98.2-14.35s58.71-40.16,63.43-75c8-59.24-50.49-110.65-45.08-170.23,6.9-76.07,108.11-105.41,127.37-179.07C2167.27,867.87,2134.41,815.44,2099,776.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M556.91,1087.29S428,542.93,160.79,245.93c-18-20-50.87-12.27-58,13.63C55.4,432.76-35.62,958.11,556.91,1087.29Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M502.68,1052.18a1.48,1.48,0,0,1-1.92,2.25c-55-40.89-267.52-241.8-346-642.17a1,1,0,0,1,2-.52C183.47,504.55,292.55,846.76,502.68,1052.18Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M518.17,670.18s51.39-391.73-50.54-654.82C460.78-2.32,437.12-5.5,426,9.82,351.2,112.28,159.36,436.3,518.17,670.18Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M491.17,633.41a1,1,0,0,1-1.83,1c-26-40.79-116-226.73-67.38-510.74a.73.73,0,0,1,1.45.16C417.75,191.79,404,445.09,491.17,633.41Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M907.81,1378.4H297c-19.48,0-35.27-12.57-35.27-28.08V880.68c0-15.48,15.74-28,35.18-28.08l615.71-1.32c19.59,0,35.46,12.63,35.36,28.23l-4.88,471C943,1365.92,927.21,1378.4,907.81,1378.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M877.88,887.23,331.7,889.9C312,890,296,902.81,296.13,918.53l3.82,395c.09,15.49,15.69,28.08,35.13,28.36l530.68,7.71c19.82.29,36.15-12.3,36.43-28.09l11.69-405.38C914.16,900.16,897.92,887.13,877.88,887.23Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M855.67,923.86v3c0,4.7-4.8,8.52-10.71,8.52H424.14c-5.92,0-10.71-3.82-10.71-8.52v-3c0-4.71,4.79-8.53,10.71-8.53H845C850.87,915.33,855.67,919.15,855.67,923.86Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M808.71,961.57h0c-.3,4.46-4.88,8-10.49,8.06l-368,5.35c-6,.08-10.9-3.76-10.9-8.53v-.69c0-4.66,4.69-8.45,10.53-8.53l368-4.64C804.06,952.51,809.05,956.64,808.71,961.57Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M846.28,1325.21H846l-497.78-4.75c-8.36-.08-16.12-3.19-21.27-8.52a19.73,19.73,0,0,1-5.83-14.16l12.81-278.9c.29-12.22,12.84-22,27.95-21.77l496.92,7.7c8.3.13,16,3.25,21.1,8.55a19.69,19.69,0,0,1,5.79,14.1v0L873.7,1303.41C873.43,1315.47,861.16,1325.21,846.28,1325.21Zm-485-324.1c-12.72,0-23.17,8-23.41,17.91l-12.81,278.9a15.49,15.49,0,0,0,4.71,11.24c4.41,4.57,11.13,7.23,18.43,7.3L846,1321.21h.29c12.72,0,23.2-8,23.42-17.93l11.94-275.93a15.57,15.57,0,0,0-4.67-11.22c-4.37-4.54-11-7.21-18.29-7.32l-496.91-7.7Zm522.35,26.31h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M877.2,1054.91H335.07a2,2,0,1,1,0-4H877.2a2,2,0,0,1,0,4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1.36,837.19A2.83,2.83,0,0,1,3.13,832C51.05,837.15,225.25,866.68,356,1027.5c119.6,147.14,179.4,270,199.81,316.56a13.16,13.16,0,0,1-13.35,18.37c-59.32-5.91-224.54-31.14-293.66-132C166.17,1109.93,124,912.91,1.36,837.19Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.09,920.41s156,58.87,401.2,425.11C543.29,1345.52,277.38,990.51,142.09,920.41Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "989.76 1026.7 956.68 1323.44 1340.54 1323.44 1290.54 1026.7 989.76 1026.7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M345,295.62V975.21a103.09,103.09,0,0,0,100.43,103.07c248.23,6.4,1116.39,21.92,1352.68,18.44a75.86,75.86,0,0,0,74.68-73.7c4.56-157.88,12-537.53-15.43-713.79a78.05,78.05,0,0,0-74.64-66.07c-208-6.65-1128.28-27.78-1364.46-22.48A74.94,74.94,0,0,0,345,295.62Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M387.59,292.31V938a59.74,59.74,0,0,0,58.84,59.73L1764.07,1014a58.14,58.14,0,0,0,59-57.91l2.2-639.9a42.51,42.51,0,0,0-41.48-42.66l-1349-27.25A46.06,46.06,0,0,0,387.59,292.31Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1833,1039.61h0L387.57,1015a1,1,0,0,1,0-2L1833,1037.61a1,1,0,0,1,0,2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1124.55,1069.69a16,16,0,1,1,16-16A16.06,16.06,0,0,1,1124.55,1069.69Zm0-30.08a14,14,0,1,0,14,14A14.06,14.06,0,0,0,1124.55,1039.61Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1423.22,1384.15H861.42c-15.27,0-26.73-10.87-23.78-22.54l7.21-28.51c2.17-8.57,11.6-14.87,22.81-15.21l541.6-16.91c11.7-.36,22.07,5.85,24.62,14.76l13,45.41C1450.25,1373,1438.73,1384.15,1423.22,1384.15Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1163.85,1324.78a1,1,0,0,1,0-2l23.21-.34h0a1,1,0,0,1,0,2l-23.21.34Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M858.44,1367.6h-.16a1,1,0,0,1-.83-1.15l3.31-20.73a22.31,22.31,0,0,1,21.74-18.82l246.16-3.6h0a1,1,0,0,1,0,2l-246.16,3.6A20.31,20.31,0,0,0,862.74,1346l-3.31,20.74A1,1,0,0,1,858.44,1367.6Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 558.6,
    y: 703.03,
    width: 62.46,
    height: 270.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 662.97,
    y: 795.92,
    width: 62.46,
    height: 177.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 767.33,
    y: 566.34,
    width: 62.46,
    height: 406.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 871.7,
    y: 875.54,
    width: 62.46,
    height: 97.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 976.07,
    y: 620.75,
    width: 62.46,
    height: 352.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1080.43,
    y: 681.79,
    width: 62.46,
    height: 291.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1184.8,
    y: 748.15,
    width: 62.46,
    height: 225.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1289.17,
    y: 484.06,
    width: 62.46,
    height: 489.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1393.53,
    y: 535.82,
    width: 62.46,
    height: 437.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1497.9,
    y: 614.11,
    width: 62.46,
    height: 359.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1602.27,
    y: 884.62,
    width: 62.46,
    height: 88.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1706.63,
    y: 712.32,
    width: 62.46,
    height: 261
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M133,567c73.3-1.08,435.93-7.43,510.35-8.74a13.14,13.14,0,0,1,13.37,13.14v33.95a13.14,13.14,0,0,1-13.14,13.14H133.23a13.14,13.14,0,0,1-13.14-13.14V580.17A13.12,13.12,0,0,1,133,567Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.45,593.19h0A13.21,13.21,0,0,0,238.9,606.4l295.73-5.13a13.21,13.21,0,0,0,12.61-16.36l-1.35-5.49a13.2,13.2,0,0,0-13.31-10.06L238.2,580A13.23,13.23,0,0,0,225.45,593.19Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M159.41,595l-45.47,46.29a4.67,4.67,0,0,0,.33,6.85l.34.28a4.34,4.34,0,0,0,6.13-.55l41.63-50.21Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.11,558c7,14.73.57,32.47-14.43,39.63s-32.86,1-39.89-13.71-.57-32.47,14.43-39.63S199.08,543.21,206.11,558Z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M164.78,541.23c-16.69,8-23.88,27.71-16.06,44.1s27.7,23.22,44.39,15.26,23.88-27.71,16.06-44.11S181.48,533.26,164.78,541.23Zm26.25,55c-14.24,6.79-31.19,1-37.87-13s-.54-30.83,13.7-37.62,31.2-1,37.87,13S205.27,589.43,191,596.23Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1499.64,1315.94s96.91,140.13,198.68,99.81c81.79-32.4-27.89-35.63-117-67.86-7-2.53-3.68-13.05,3.5-11.11,70.55,19,179.1,41.33,203.1,6.4,36.21-52.72,5.92-38.08-82.6-41.5s-102.52-27.24-43.66-33.12,145.73,35.88,170.54,11,43.65-78.23,55.21-100.73-101-73.46-136.84-46.66-70.73,92.58-110,100.23,9.28-48.2,38.42-76.48,42.14-50.45-8.72-49.52-85.27,58.29-96.54,103-32.2,67.8-28.43,45.44,21.06-90.21,39.74-108.82S1486.56,1137.67,1499.64,1315.94Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1508.72,1318.36a1.49,1.49,0,0,0,1.55-.07c108.68-72.31,280.24-112.61,282-113a1.5,1.5,0,1,0-.68-2.93c-1.72.39-173.8,40.81-283,113.43a1.5,1.5,0,0,0,.12,2.57Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1420.56,1386.77s206.32,34.28,257.71-89.88c41.31-99.79-55.23-5.86-159.79,45.18-8.21,4-14.65-7.9-6.81-12.58,77.06-45.94,189.44-122.59,179.15-173.57-15.54-77-28.51-37.76-107.15,37.37s-111.59,67.1-66.5,10.18,156.13-97.82,155.42-140.93S1640.91,957.22,1631,927.82s-151.07,26.31-158,80.77,21.19,141.45-5.64,182.63-34.56-49.36-34.6-99.21-8.48-80.26-51.1-34.62-21.46,125,8.34,173.12,32.27,86.31,15.77,63.88-61.53-95.62-62-128S1252.21,1246,1420.56,1386.77Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1430.44,1380.83a1.85,1.85,0,0,0,1.26-1.43c29.1-157.58,140.14-343.25,141.26-345.11a1.85,1.85,0,1,0-3.17-1.9c-1.12,1.86-112.5,188.09-141.72,346.35a1.85,1.85,0,0,0,1.48,2.15A1.9,1.9,0,0,0,1430.44,1380.83Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1131.79,
    cy: 551.84,
    r: 384.44,
    transform: "translate(-58.72 961.93) rotate(-45)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1131.79,
    cy: 551.84,
    r: 328.11
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1131.79,885.45a333.62,333.62,0,1,1,235.89-97.71A331.43,331.43,0,0,1,1131.79,885.45Zm0-656.22C953.9,229.23,809.18,374,809.18,551.84S953.9,874.45,1131.79,874.45,1454.4,729.73,1454.4,551.84,1309.68,229.23,1131.79,229.23Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 1131.79,
    cy: 551.84,
    r: 200.03,
    transform: "translate(-58.72 961.93) rotate(-45)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1131.79,757.37c-113.33,0-205.53-92.2-205.53-205.53s92.2-205.53,205.53-205.53,205.53,92.2,205.53,205.53S1245.12,757.37,1131.79,757.37Zm0-400.06c-107.27,0-194.53,87.27-194.53,194.53s87.26,194.53,194.53,194.53,194.53-87.26,194.53-194.53S1239.05,357.31,1131.79,357.31Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1131.79,
    cy: 551.84,
    r: 77.5,
    transform: "translate(334.68 1526.57) rotate(-76.72)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1131.79,634.84a83,83,0,1,1,83-83A83.09,83.09,0,0,1,1131.79,634.84Zm0-155a72,72,0,1,0,72,72A72.08,72.08,0,0,0,1131.79,479.84Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1382.52,
    y: 9.5,
    width: 14.65,
    height: 554.87,
    transform: "translate(2169.74 1472.59) rotate(-135)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1195.83,452.93c6-5.95,34,22.08,28,28l-103.94,81.71a4.13,4.13,0,0,1-5.8-5.8Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1591,96.16l52.79,5.25-72.46,72.46a112,112,0,0,1-90.3,32.26h0Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1580.62,85.8,1575.38,33l-72.46,72.47a112,112,0,0,0-32.27,90.29h0Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1550.84,363.55l2.65,144.75c.21,15.27,10.2,27.52,22.46,27.52H2085.6c12.41,0,22.46-12.53,22.46-28V375.68c0-15.11-9.61-27.49-21.73-28L1574,335.11C1561.19,334.59,1550.63,347.55,1550.84,363.55Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1576.48,382.71l6.72,128.94c.26,6.94,4.9,12.37,10.48,12.25l482-6.19c5.62-.12,10.13-5.84,10.13-12.84V399.93c0-6.85-4.31-12.49-9.8-12.83l-488.69-17.82C1581.21,368.91,1576.2,375.14,1576.48,382.71Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1599,399.66v13c0,4.59,3,8.29,6.7,8.21L2048.86,416c3.6-.08,6.49-3.73,6.49-8.22h0c0-4.45-2.85-8.1-6.42-8.21l-443.19-8.08C1602,391.32,1599,395,1599,399.66Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1602.6,448.86V460.8c0,4.66,3.09,8.38,6.82,8.22L2041,459c3.56-.15,6.37-3.78,6.37-8.21V447c0-4.56-3-8.25-6.64-8.22l-431.62,1.83C1605.52,440.67,1602.6,444.34,1602.6,448.86Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1737.87,604.79l1.64,90c.13,9.5,6.35,17.11,14,17.11h316.79c7.71,0,14-7.79,14-17.4V612.33c0-9.39-6-17.09-13.51-17.39l-318.43-7.83C1744.3,586.79,1737.73,594.85,1737.87,604.79Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1753.8,616.7l4.18,80.14c.16,4.32,3,7.69,6.51,7.62l299.58-3.85c3.49-.07,6.29-3.63,6.29-8V627.4c0-4.25-2.68-7.76-6.09-8l-303.75-11.07C1756.74,608.12,1753.63,612,1753.8,616.7Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1767.78,627.24v8.09c0,2.86,1.88,5.16,4.17,5.11l275.47-3.07c2.24,0,4-2.32,4-5.11h0c0-2.77-1.77-5-4-5.11l-275.47-5C1769.68,622.05,1767.78,624.36,1767.78,627.24Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1770,657.82v7.42c0,2.89,1.92,5.21,4.24,5.11l268.28-6.25c2.21-.1,4-2.36,4-5.11v-2.31c0-2.84-1.85-5.13-4.12-5.11l-268.29,1.14C1771.86,652.73,1770,655,1770,657.82Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M578.08,829.17s-12.41,6-14.69,13c-1.83,5.57-15.55,6.28-16.91,17.23a12.55,12.55,0,0,1-10.5,11c-14,2.15-35.62,9.43-39.07,33.76-2.64,18.57,6.83,25.62,16.77,28.05a14.09,14.09,0,0,1,10.67,16.26c-1.42,7.07.69,15.24,12.94,21.7,27.43,14.48,54.83-34.3,54.83-34.3l5.62-85.16Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M707.23,784.26s-35.3,96.24-95.45,126.32c0,0,20,32.67,30.47,34.65,0,0,64.26-82.25,70.81-149.63Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M465.31,1363.18l-1.78,14.59a6,6,0,0,1-5.28,5.28,93.52,93.52,0,0,1-19.54.3,5.15,5.15,0,0,1-4.33-6.69c1.79-5.64,5.06-14.1,9.79-19.07h16.19A5,5,0,0,1,465.31,1363.18Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M592.12,1192.2l2.74,16.08s-9.16,92.69-10.78,129.77a29,29,0,0,0,4.3,16.52l15.91,25.84-40.44-23.87-.81-4.93,6.62-9.11L561,1238.66a31.81,31.81,0,0,1,3.63-17.62l8.36-15.72Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M607,1384.15h-12.9a7.77,7.77,0,0,1-6.17-3c-4-5.23-12.36-15.43-16.35-15.7-5.36-.36-4.68,18.72-4.68,18.72h-3l-3.81-23.7a14,14,0,0,1,7.36-14.67h0s1.23,9.07,7.88,13.08,27.06,18.38,27.06,18.38a18.75,18.75,0,0,1,5.25.14C611.66,1378.12,611.09,1384.15,607,1384.15Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M536.73,1199.84s-53.61,101.69-62.13,124.91-11.51,42.59-11.63,44.43c-.18,2.86-3.74,5.61-13.57,5.61-5.07,0-7.55-2-8.77-4a5.71,5.71,0,0,1-.21-5.55c3.1-6.27,12.94-26.33,16.58-35.43,4.35-10.86,13.72-60.08,18.85-77.2s10.94-35.67,33.29-52.77C509.14,1199.84,524.49,1184.8,536.73,1199.84Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M570.6,1033.2c13.83-58.6-21.21-91.74-21.21-91.74,22.11-21.22,62.39-30.88,62.39-30.88s38.43,28.1,33.87,50.09c-2.67,12.89-27,77.21-27,77.21S596.13,1048.53,570.6,1033.2Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M539.94,1062.21c5.62-17,30.66-29,30.66-29,25.53,15.33,48,4.68,48,4.68s5,19.29,1.57,37.23-25.34,133.17-25.34,133.17c-34.45,7-87.42-7-87.42-7C529.38,1162.3,534.31,1079.17,539.94,1062.21Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M586.65,871.85l-11.24,50.51c-1.08,4.45,3,3.72,7.47,2.87,7.37-1.39,16.86-4.25,20-10a5.25,5.25,0,0,0,.58-1.9l4.83-35a6.29,6.29,0,0,0-3.68-6.61l-9.32-4.14A6.3,6.3,0,0,0,586.65,871.85Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M549.39,941.46s-78.47,56.14-10,115.14a17.66,17.66,0,0,0,7.74,4.48c2.59.78,10.26,6.58,14.15,9.6a2.64,2.64,0,0,0,3.89-.7h0a3.62,3.62,0,0,0,.21-3.48L555.63,1046a7.49,7.49,0,0,0-9.73-.42h0a3.7,3.7,0,0,1-5.61-1.27C535,1033.49,525,1001.79,565.9,966a4.41,4.41,0,0,0,1-5.38C564,955.08,557.44,944.12,549.39,941.46Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M599.84,823.77s13.32,5.62,22.37,24.86,2.3,28.13-6.2,29.35-21.19,1-34.63-11.4S582.53,817.1,599.84,823.77Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M590.41,856.31s-10-28.15,14.92-28.49l5.87,4.11s9.16-15.61-5.87-23.06-32.63-1.3-39,19-7.49,33.81,3.15,43.5,15-1.3,15-1.3-5.8-9.06-3.44-13.91,7.8,1,7.8,1Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M587.61,859.45s-5.07-14.51-11.85-8.73,5.51,13.39,10.32,15.86Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M710.62,801.78c.54,1.71-5.7,4.32-9.37-2.69-.13-3.35-2.17-17.73-.16-20.47,10.68-14.56,31.39-32.81,31.39-32.81a4.92,4.92,0,0,1,.61,6.84l-10,10.47c2.1,3.8,4.66,7,5.86,11.59a14.08,14.08,0,0,1-1.4,10.37c-1.76,3.17-4.17,7.3-6.44,10.53A13.92,13.92,0,0,1,710.62,801.78Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M715.28,794.54l-1-.18c.11-.63,2.78-15.46,4.85-18.82.87-1.43,1.19-2.59,1-3.47a2.75,2.75,0,0,0-1.38-1.56l-8.8,7.46-2.83,7.6-.93-.35,2.92-7.85,9.51-8.06.29.15a3.86,3.86,0,0,1,2.18,2.34c.33,1.17,0,2.57-1.06,4.26C718,779.26,715.31,794.39,715.28,794.54Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1989.22,1241.23c2.92,4.32,14.54,102.26,16.36,138.43a4.28,4.28,0,0,1-4.28,4.49h0a4.29,4.29,0,0,1-4.24-3.63l-21.25-136.18Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1895.81,1241.23c-2.93,4.32-14.55,102.26-16.36,138.43a4.27,4.27,0,0,0,4.28,4.49h0a4.28,4.28,0,0,0,4.23-3.63l21.26-136.18Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2006.79,1233.58v1.07c.07,7.68-6.55,14-14.83,14.13l-98.23,1.67c-8.17.14-15-5.77-15.38-13.33l0-1c-.41-7.89,6.29-14.53,14.81-14.69l98.27-1.76C1999.8,1219.54,2006.72,1225.78,2006.79,1233.58Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1815.7,1376.11c17.46,0,25.19-1.5,28.64-2.87a6.61,6.61,0,0,1-6.45,5.13h-61.77a3,3,0,0,1-2.9-3.79C1780.26,1375.15,1795.22,1376.11,1815.7,1376.11Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1773.22,1374.58a2.92,2.92,0,0,1,.51-1c4.7-6,14.16-15.44,27-15.26,18.84.26,25.41,2.31,40,.11l3.45,11.45a6.5,6.5,0,0,1,.1,3.41c-3.45,1.37-11.18,2.87-28.64,2.87C1795.22,1376.11,1780.26,1375.15,1773.22,1374.58Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1836.55,1346.05l4.24,14.41s-9.39,4.28-17.65.85l-1.63-12.49Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1708.52,1367c13.61,10.93,20.56,14.61,24.11,15.71a6.6,6.6,0,0,1-8.23-.06L1676.25,1344a3,3,0,0,1,.1-4.75C1681.49,1344.09,1692.55,1354.2,1708.52,1367Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1676.35,1339.24a2.92,2.92,0,0,1,1.05-.5c7.42-1.72,20.67-3.12,30.58,5.08,14.52,12,18.36,17.7,31.14,25.17l-4.44,11a6.54,6.54,0,0,1-2,2.71c-3.55-1.1-10.5-4.78-24.11-15.71C1692.55,1354.2,1681.49,1344.09,1676.35,1339.24Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1927.22,1181.8s-104.54,8.53-126,18.63,17.5,151.59,17.5,151.59,5.84,2.81,18.83-1.23c0,0-13.32-104.42-3.41-127.06l113.19-18.51Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1749.51,1349.11c-1,.89-10.39,19.88-10.39,19.88s-10.48-2.27-12.62-8.91l9.43-17.14Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1990.19,1180.92a53,53,0,0,1,3.26,19.09,28.67,28.67,0,0,1-27.35,28l-123.58,5.63a5.93,5.93,0,0,0-5.47,4.46c-2.91,11.23-17.1,45.72-86.49,114.56a5.59,5.59,0,0,1-6.92.75l-9.88-6.24a2.27,2.27,0,0,1-.75-3.07l72-122.88a27.87,27.87,0,0,1,16.92-12.55l105.33-26.92Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1868.4,989s13.23,23.41,26.73,34.75l-27.9,15.56s-6.28-24.78-20.65-32Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1992.43,1181.8s-33.36,8.13-65.21,0c0,0-44.56-59.9-61.8-76.21,0,0-27.5,43.39-88.7,49.54l-3.42-7.62s48.73-22.47,63.73-57,21-49.23,34.67-58.24c8.5-5.61,13.59-9.44,16.22-11.53a4.35,4.35,0,0,1,5-.32C1907.4,1029.27,1975.55,1075.94,1992.43,1181.8Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1867.23,1104.85a2.23,2.23,0,0,1-1.36-.46,2.26,2.26,0,0,1-.42-3.15,130.8,130.8,0,0,0,16.18-28.67,2.24,2.24,0,1,1,4.18,1.61A132.44,132.44,0,0,1,1869,1104,2.23,2.23,0,0,1,1867.23,1104.85Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1780.4,1143.52l-6.89-1.83-20.92-4.85a9.69,9.69,0,0,0-7.35,1.24l-18,11.32,49.67-.09Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1847.38,953.88s-12.87,21.39-15.1,33.21-5.82,19.21,7.63,23.42,26-1.12,33.81-12.15c0,0,12.25-17,11-24.76S1847.38,953.88,1847.38,953.88Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1870.14,989.21l-1.74-.23s9.11-13.77,3.14-17.18-30.25-11.8-34.47-21.36c-4.07-9.23,2-19.65,9.35-21.82a.94.94,0,0,1,1.13.59l.43,1.16a.94.94,0,0,0,1.74,0h0a.94.94,0,0,1,1.71,0c1.3,2.86,5.2,7.76,16.88,11.54,16.58,5.38,26.91,13.73,25.64,25.51a.94.94,0,0,0,1.34,1c1.36-.6,3.41-.69,5.8,1.92,4.15,4.53.9,14.46-10.43,21.48a.93.93,0,0,0-.16,1.5c1.7,1.46,4.08,4.69-3.58,7.58-7.84,3-12.12,2-13.7,1.31a.93.93,0,0,1-.58-1.06l2-10.32a.94.94,0,0,0-.8-1.11Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1869.42,991.33s5.68-14,11.64-9.08-5.51,15.8-10.81,15.65Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1799.59,1159.14h-.25l-106.11-.11a4.74,4.74,0,1,1,0-9.48l106.1.1a4.74,4.74,0,0,1,.24,9.48Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1652.14,1055.23a1.51,1.51,0,0,1,.11.22l44.65,96.25a4.74,4.74,0,1,1-8.61,4l-44.64-96.26a4.74,4.74,0,0,1,8.49-4.2Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1752.34,1164.47c.46,1.92,44.74,168,56,210.06a7.61,7.61,0,0,1-7.28,9.62h0a7.57,7.57,0,0,1-7.32-5.79l-49.15-199.26Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1728.1,1164.47c-.47,1.92-44.74,168-56,210.06a7.61,7.61,0,0,0,7.29,9.62h0a7.55,7.55,0,0,0,7.31-5.79l49.15-199.26Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1726.25,1159h27.57v22.14a5.72,5.72,0,0,1-5.69,5.76h-3.78v49.74a4.34,4.34,0,0,1-4.31,4.37h0a4.34,4.34,0,0,1-4.31-4.37v-49.74h-1.92a7.6,7.6,0,0,1-7.56-7.64Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1821.63,1153.72h-154a4.73,4.73,0,0,0-4.57,3.58l-2.15,8.43a4.76,4.76,0,0,0,4.59,6l158-.92a4.77,4.77,0,0,0,4.55-5.94l-1.87-7.51A4.72,4.72,0,0,0,1821.63,1153.72Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1053.3,1383.83H687.17c-11.68,0-21.14-4.45-21.14-9.93v-166c0-5.47,9.43-9.91,21.08-9.93l369.06-.46c11.75,0,21.26,4.46,21.2,10L1074.44,1374C1074.38,1379.42,1064.93,1383.83,1053.3,1383.83Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1035.36,1210.23l-327.38,1c-11.84,0-21.38,4.56-21.32,10.12l2.28,139.6c.06,5.47,9.41,9.92,21.06,10l318.1,2.73c11.88.1,21.67-4.35,21.84-9.93l7-143.27C1057.11,1214.8,1047.38,1210.2,1035.36,1210.23Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1022.05,1223.18v1.06c0,1.66-2.87,3-6.42,3H763.39c-3.55,0-6.42-1.35-6.42-3v-1.06c0-1.66,2.87-3,6.42-3h252.24C1019.18,1220.17,1022.05,1221.52,1022.05,1223.18Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M993.91,1236.51h0c-.19,1.58-2.93,2.82-6.3,2.85L767,1241.25c-3.59,0-6.53-1.33-6.53-3V1238c0-1.65,2.81-3,6.31-3l220.61-1.65C991.12,1233.31,994.11,1234.77,993.91,1236.51Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1016.43,1366.32h-.2l-298.38-1.68c-6.53,0-12.35-1.89-15.17-4.85a6.14,6.14,0,0,1-1.87-4.52l7.68-98.63c.2-5.05,7.58-8.87,17.21-8.87H726l297.86,2.72c6.48.06,12.25,1.92,15,4.85a6.17,6.17,0,0,1,1.88,4.51s0,0,0,.07l-7.15,97.51C1033.47,1362.49,1026.07,1366.32,1016.43,1366.32ZM725.71,1251.77c-8,0-13.14,3-13.23,5.11l-7.68,98.62a2.26,2.26,0,0,0,.78,1.53c1.69,1.77,6.15,3.58,12.29,3.61l298.38,1.68h.18c8,0,13.15-3,13.23-5.1l7.16-97.54a2.3,2.3,0,0,0-.77-1.57c-1.68-1.76-6.1-3.56-12.19-3.61L726,1251.78Zm313.11,8h0Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1035,1270.79H710a2,2,0,0,1,0-4h325a2,2,0,0,1,0,4Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1363.05,1343.2l-1.52-2.57v0a1.52,1.52,0,0,1,2.61-1.54h0l1.52,2.6a1.5,1.5,0,1,1-2.59,1.52Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1357.89,1334.69l-1.6-2.52v0a1.53,1.53,0,0,1,2.59-1.64h0l1.61,2.55a1.53,1.53,0,0,1-2.59,1.62Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1352.46,1326.34l-1.67-2.46v0a1.55,1.55,0,1,1,2.57-1.74h0l1.69,2.5a1.55,1.55,0,1,1-2.57,1.73Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1346.78,1318.18l-1.75-2.42h0a1.58,1.58,0,1,1,2.55-1.85h0l1.76,2.45a1.57,1.57,0,1,1-2.54,1.83Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1340.85,1310.19l-1.83-2.36v0a1.6,1.6,0,0,1,2.53-2h0l1.84,2.39a1.59,1.59,0,1,1-2.53,1.93Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1334.68,1302.38l-1.9-2.3h0a1.62,1.62,0,0,1,2.5-2.06h0l1.91,2.33a1.61,1.61,0,1,1-2.5,2Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1328.27,1294.77l-2-2.25h0a1.64,1.64,0,0,1,2.46-2.16h0l2,2.28a1.63,1.63,0,1,1-2.46,2.13Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1321.64,1287.35l-2-2.19h0a1.66,1.66,0,1,1,2.43-2.26h0l2,2.22a1.65,1.65,0,0,1-2.43,2.23Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1314.8,1280.12l-2.09-2.13h0a1.68,1.68,0,1,1,2.39-2.35h0l2.1,2.16a1.67,1.67,0,1,1-2.39,2.34Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1307.75,1273.1l-2.15-2.07h0a1.7,1.7,0,1,1,2.36-2.45h0l2.17,2.1a1.69,1.69,0,0,1-2.36,2.43Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1300.51,1266.28l-2.21-2h0a1.72,1.72,0,1,1,2.31-2.55h0l2.22,2a1.71,1.71,0,1,1-2.31,2.53Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1293.08,1259.66l-2.26-2h0a1.74,1.74,0,1,1,2.27-2.64h0l2.28,2a1.73,1.73,0,0,1-2.27,2.62Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1285.47,1253.24l-2.31-1.88h0a1.76,1.76,0,0,1,2.23-2.73h0l2.33,1.91a1.76,1.76,0,0,1-2.23,2.72Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1277.69,1247l-2.36-1.82h0a1.78,1.78,0,1,1,2.17-2.83h0l2.38,1.84a1.78,1.78,0,0,1-2.18,2.81Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1269.75,1241l-2.41-1.76h0a1.81,1.81,0,0,1,2.13-2.92h0l2.43,1.78a1.8,1.8,0,0,1-2.13,2.9Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1261.66,1235.25l-2.46-1.7h0a1.83,1.83,0,0,1,2.08-3h0l2.48,1.72a1.82,1.82,0,0,1-2.08,3Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1253.42,1229.66l-2.5-1.63h0a1.85,1.85,0,0,1,2-3.09h0l2.51,1.66a1.84,1.84,0,1,1-2,3.07Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1245,1224.29l-2.53-1.58h0a1.87,1.87,0,0,1,2-3.18h0l2.55,1.59a1.86,1.86,0,0,1-2,3.16Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1236.54,1219.12l-2.58-1.51h0a1.89,1.89,0,0,1,1.91-3.26h0l2.59,1.53a1.88,1.88,0,1,1-1.92,3.24Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1227.91,1214.15l-2.61-1.44h0a1.91,1.91,0,1,1,1.85-3.34h0l2.63,1.47a1.9,1.9,0,1,1-1.86,3.32Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1219.16,1209.4l-2.64-1.39h0a1.93,1.93,0,1,1,1.79-3.42h0L1221,1206a1.92,1.92,0,0,1-1.8,3.4Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1210.31,1204.85l-2.68-1.32h0a1.95,1.95,0,0,1,1.73-3.49h0l2.69,1.35a1.94,1.94,0,1,1-1.74,3.47Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1201.35,1200.51l-2.71-1.26h0a2,2,0,1,1,1.67-3.57h0L1203,1197a2,2,0,1,1-1.68,3.55Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1192.3,1196.37l-2.74-1.2h0a2,2,0,0,1,1.6-3.65h0l2.75,1.23a2,2,0,0,1,1,2.62,2,2,0,0,1-2.62,1Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1183.15,1192.44l-2.75-1.14h0a2,2,0,0,1,1.54-3.71h0l2.78,1.16a2,2,0,1,1-1.54,3.7Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1173.93,1188.7l-2.79-1.08h0a2,2,0,0,1,1.46-3.77h0l2.8,1.1a2,2,0,1,1-1.46,3.76Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1164.62,1185.17l-2.81-1h0a2,2,0,1,1,1.38-3.82h0l2.83,1a2,2,0,0,1,1.21,2.61,2,2,0,0,1-2.6,1.2Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1155.23,1181.84l-2.82-1h0a2,2,0,1,1,1.32-3.87h0l2.85,1a2,2,0,1,1-1.32,3.86Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M1145.78,1178.71l-2.85-.9h0a2.06,2.06,0,1,1,1.24-3.92h0l2.87.91a2.06,2.06,0,1,1-1.24,3.92Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1136.26,1175.79l-2.86-.84h0a2.07,2.07,0,0,1,1.16-4h0l2.89.85a2.06,2.06,0,1,1-1.17,4Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1126.69,1173.07l-2.89-.78h0a2.08,2.08,0,0,1,1.08-4h0l2.9.79a2.08,2.08,0,0,1-1.08,4Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1117.06,1170.55l-2.9-.72h0a2.09,2.09,0,1,1,1-4.06h0l2.92.73a2.09,2.09,0,0,1-1,4Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1107.37,1168.23l-2.91-.65h0a2.1,2.1,0,1,1,.92-4.1h0l2.94.67a2.1,2.1,0,0,1-.93,4.09Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M1097.64,1166.12l-2.92-.6h0a2.11,2.11,0,1,1,.84-4.14h0l3,.61a2.11,2.11,0,0,1-.85,4.13Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1087.87,1164.21l-2.94-.53h0a2.12,2.12,0,0,1,.76-4.18h0l3,.55a2.12,2.12,0,0,1-.77,4.17Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M1078.06,1162.5l-2.94-.47h0a2.14,2.14,0,0,1,.68-4.22h0l3,.48a2.14,2.14,0,0,1-.69,4.22Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M1068.22,1161l-3-.41h0a2.15,2.15,0,0,1,.59-4.26h0l3,.43a2.14,2.14,0,1,1-.6,4.24Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1058.35,1159.71l-3-.35h0a2.16,2.16,0,0,1,.5-4.29h0l3,.36a2.16,2.16,0,1,1-.51,4.28Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M1048.45,1158.62l-3-.28h0a2.17,2.17,0,1,1,.41-4.32h0l3,.29a2.17,2.17,0,0,1-.43,4.32Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1038.54,1157.74l-3-.23h0a2.19,2.19,0,0,1,.33-4.36h0l3,.24a2.18,2.18,0,0,1-.35,4.35Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M1028.6,1157l-3-.17h0a2.19,2.19,0,1,1,.25-4.38h0l3,.18a2.19,2.19,0,0,1-.27,4.38Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M1018.66,1156.52l-3-.12h0a2.21,2.21,0,1,1,.18-4.41h0l3,.13a2.2,2.2,0,1,1-.19,4.4Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M1008.7,1156.18l-3-.06h0a2.22,2.22,0,0,1,.1-4.44h0l3,.07a2.22,2.22,0,1,1-.11,4.43Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M998.74,1156l-3,0h0a2.23,2.23,0,1,1,0-4.46h0l3,0a2.23,2.23,0,0,1,0,4.46Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M988.78,1156l-3,0h0a2.24,2.24,0,1,1,0-4.48h0l3,0a2.24,2.24,0,1,1,0,4.48Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M978.82,1156.21l-3,.08h0a2.26,2.26,0,1,1-.13-4.51h0l3-.08a2.26,2.26,0,0,1,.12,4.51Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M968.87,1156.55l-3,.14h0a2.28,2.28,0,0,1-2.37-2.17,2.25,2.25,0,0,1,2.16-2.36h0l3-.13a2.26,2.26,0,0,1,.19,4.52Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M958.92,1157.06l-3,.18h0a2.28,2.28,0,0,1-.28-4.55h0l3-.17a2.27,2.27,0,1,1,.27,4.54Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M949,1157.72l-3,.23h0a2.29,2.29,0,0,1-.35-4.57h0l3-.23a2.29,2.29,0,0,1,.34,4.56Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M939,1158.55l-3,.27h0a2.3,2.3,0,1,1-.43-4.58h0l3-.27a2.3,2.3,0,0,1,.42,4.58Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M929.13,1159.52l-3,.32h0a2.31,2.31,0,0,1-.49-4.6h0l3-.31a2.31,2.31,0,1,1,.48,4.59Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M919.23,1160.64l-3,.37h0a2.33,2.33,0,0,1-.57-4.62h0l3-.36a2.32,2.32,0,1,1,.56,4.61Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M909.34,1161.91l-3,.41h0a2.34,2.34,0,1,1-.64-4.63h0l3-.41a2.34,2.34,0,0,1,.62,4.63Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M899.47,1163.32l-3,.45h0a2.35,2.35,0,1,1-.7-4.64h0l3-.45a2.35,2.35,0,0,1,.7,4.64Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M889.63,1164.86l-3,.48h0a2.35,2.35,0,1,1-.77-4.64h0l3-.49a2.35,2.35,0,1,1,.76,4.64Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M879.8,1166.53l-2.95.53h0a2.36,2.36,0,1,1-.83-4.64h0l3-.53a2.36,2.36,0,0,1,.83,4.64Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M870,1168.33l-2.93.57h0a2.36,2.36,0,1,1-.89-4.63h0l3-.57a2.36,2.36,0,1,1,.89,4.63Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M860.21,1170.26l-2.93.6h0a2.36,2.36,0,1,1-.95-4.62h0l2.95-.61a2.36,2.36,0,1,1,1,4.63Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M850.45,1172.31l-2.92.64h0a2.36,2.36,0,0,1-1-4.62h0l2.94-.64a2.36,2.36,0,1,1,1,4.62Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M840.72,1174.48l-2.91.67h0a2.37,2.37,0,0,1-1.07-4.62h0l2.94-.68a2.37,2.37,0,0,1,1.06,4.62Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M831,1176.77l-2.91.7h0a2.38,2.38,0,0,1-1.13-4.62h0l2.92-.7a2.37,2.37,0,1,1,1.12,4.61Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M821.34,1179.16l-2.9.75h0a2.38,2.38,0,0,1-1.18-4.61h0l2.91-.74a2.37,2.37,0,0,1,1.18,4.6Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M811.69,1181.67l-2.89.77h0a2.38,2.38,0,0,1-1.23-4.6h0l2.9-.78a2.38,2.38,0,0,1,1.23,4.6Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M802.07,1184.28l-2.88.81h0a2.38,2.38,0,1,1-1.28-4.59h0l2.9-.81a2.38,2.38,0,1,1,1.27,4.59Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M792.47,1187l-2.88.83h0a2.39,2.39,0,0,1-1.34-4.59h0l2.89-.84a2.39,2.39,0,0,1,1.32,4.59Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M782.89,1189.82l-2.86.86h0a2.39,2.39,0,0,1-1.38-4.58h0l2.88-.87a2.4,2.4,0,0,1,1.38,4.59Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M773.35,1192.73l-2.86.89h0a2.39,2.39,0,0,1-1.43-4.57h0l2.87-.9a2.4,2.4,0,0,1,1.42,4.58Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M763.83,1195.73l-2.85.92h0a2.4,2.4,0,1,1-1.47-4.56h0l2.87-.93a2.4,2.4,0,1,1,1.47,4.57Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M754.34,1198.83l-2.84.94h0a2.41,2.41,0,0,1-1.52-4.57h0l2.86-1a2.41,2.41,0,0,1,1.52,4.57Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M744.88,1202l-2.83,1h0a2.41,2.41,0,1,1-1.56-4.55h0l2.85-1a2.41,2.41,0,0,1,1.55,4.56Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M735.45,1205.27l-2.82,1h0a2.41,2.41,0,1,1-1.6-4.55h0l2.83-1a2.41,2.41,0,1,1,1.6,4.55Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M726.05,1208.62l-2.82,1h0a2.42,2.42,0,1,1-1.65-4.54h0l2.83-1a2.41,2.41,0,1,1,1.64,4.54Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M716.67,1212l-2.8,1h0a2.42,2.42,0,0,1-1.68-4.54h0l2.82-1a2.42,2.42,0,0,1,1.68,4.53Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M707.33,1215.54l-2.81,1.07h0a2.42,2.42,0,1,1-1.73-4.53h0l2.81-1.07a2.42,2.42,0,0,1,1.72,4.53Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M698,1219.12l-2.79,1.08h0a2.43,2.43,0,0,1-1.76-4.53h0l2.81-1.09a2.43,2.43,0,1,1,1.75,4.53Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M688.7,1222.76l-2.78,1.11h0a2.43,2.43,0,0,1-1.79-4.52h0l2.8-1.11a2.43,2.43,0,0,1,1.79,4.52Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M679.43,1226.47l-2.77,1.13h0a2.43,2.43,0,1,1-1.83-4.51h0l2.79-1.13a2.43,2.43,0,1,1,1.82,4.51Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M670.19,1230.25l-2.77,1.15a2.44,2.44,0,1,1-1.87-4.51h0l2.78-1.15a2.44,2.44,0,0,1,1.86,4.51Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M661,1234.08l-2.76,1.16a2.44,2.44,0,1,1-1.9-4.5h0l2.77-1.16a2.44,2.44,0,1,1,1.88,4.5Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M651.75,1238l-2.76,1.17a2.45,2.45,0,0,1-1.91-4.51h0l2.77-1.17a2.45,2.45,0,0,1,1.9,4.51Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M642.55,1241.86,639.8,1243a2.45,2.45,0,0,1-1.93-4.51h0l2.77-1.17a2.44,2.44,0,1,1,1.91,4.5Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M633.36,1245.79,630.6,1247a2.45,2.45,0,0,1-1.93-4.51h0l2.76-1.18a2.45,2.45,0,1,1,1.93,4.51Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M624.17,1249.72l-2.76,1.18a2.46,2.46,0,1,1-1.93-4.52h0l2.76-1.17a2.45,2.45,0,1,1,1.93,4.51Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M615,1253.66l-2.76,1.18a2.46,2.46,0,1,1-1.93-4.53h0l2.76-1.18a2.46,2.46,0,0,1,1.93,4.53Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M605.77,1257.58l-2.76,1.17a2.47,2.47,0,1,1-1.93-4.54h0l2.76-1.17a2.47,2.47,0,0,1,1.93,4.54Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M596.55,1261.48l-2.76,1.17a2.47,2.47,0,0,1-1.92-4.56h0l2.77-1.16a2.47,2.47,0,0,1,1.91,4.55Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M587.32,1265.35l-2.77,1.15a2.47,2.47,0,1,1-1.9-4.57h0l2.77-1.15a2.47,2.47,0,0,1,1.9,4.57Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M578.07,1269.18l-2.78,1.13a2.48,2.48,0,1,1-1.88-4.58h0l2.77-1.13a2.48,2.48,0,0,1,1.88,4.59Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M568.79,1273l-2.79,1.12a2.48,2.48,0,0,1-1.85-4.61h0l2.78-1.12h0a2.48,2.48,0,1,1,1.85,4.61Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M559.48,1276.65l-2.8,1.1a2.49,2.49,0,1,1-1.81-4.63h0l2.79-1.09h0a2.48,2.48,0,1,1,1.81,4.62Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M550.14,1280.29l-2.81,1.07a2.49,2.49,0,0,1-1.78-4.65h0l2.8-1.06h0a2.49,2.49,0,1,1,1.77,4.65Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M540.76,1283.83l-2.82,1a2.49,2.49,0,0,1-1.73-4.67h0l2.8-1h0a2.49,2.49,0,0,1,1.73,4.68Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M531.34,1287.27l-2.83,1a2.5,2.5,0,0,1-1.68-4.71h0l2.82-1h0a2.49,2.49,0,0,1,1.67,4.7Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M521.88,1290.61l-2.85,1a2.5,2.5,0,1,1-1.61-4.73h0l2.83-1h0a2.5,2.5,0,1,1,1.62,4.73Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M512.37,1293.81l-2.86.93A2.49,2.49,0,1,1,508,1290h0l2.84-.93h0a2.5,2.5,0,0,1,1.55,4.75Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M502.81,1296.88l-2.87.89a2.49,2.49,0,0,1-1.48-4.76h0l2.86-.88h0a2.5,2.5,0,0,1,1.48,4.77Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M493.21,1299.79l-2.9.84a2.48,2.48,0,1,1-1.39-4.77h0l2.87-.84h0a2.49,2.49,0,0,1,1.4,4.78Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M483.55,1302.54l-2.91.79a2.48,2.48,0,1,1-1.31-4.79h0l2.88-.78h0a2.49,2.49,0,0,1,1.31,4.8Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M473.83,1305.12l-2.92.73a2.48,2.48,0,1,1-1.21-4.81h0l2.9-.73h0a2.48,2.48,0,1,1,1.21,4.82Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M464.07,1307.5l-2.94.67a2.48,2.48,0,1,1-1.11-4.83h0l2.91-.67h0a2.48,2.48,0,0,1,1.11,4.84Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M454.25,1309.67l-2.95.61a2.48,2.48,0,0,1-1-4.85h0l2.91-.6h0a2.48,2.48,0,1,1,1,4.85Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M444.39,1311.63l-3,.54a2.47,2.47,0,0,1-.88-4.87h0l2.93-.54h0a2.48,2.48,0,0,1,.89,4.87Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M434.48,1313.34l-3,.47a2.47,2.47,0,1,1-.76-4.88h0l2.94-.46h0a2.47,2.47,0,1,1,.77,4.88Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M424.52,1314.81l-3,.39a2.47,2.47,0,1,1-.64-4.89h0l2.95-.39h0a2.47,2.47,0,1,1,.64,4.89Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M414.53,1316l-3,.31a2.46,2.46,0,1,1-.5-4.9h0l3-.31h0a2.46,2.46,0,1,1,.51,4.9Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M404.5,1316.93l-3,.22a2.46,2.46,0,1,1-.36-4.9h0l3-.22h0a2.46,2.46,0,0,1,.36,4.9Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M394.45,1317.57l-3,.13a2.46,2.46,0,0,1-.22-4.91h0l3-.13h0a2.46,2.46,0,0,1,.22,4.91Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M384.38,1317.89l-3,0a2.45,2.45,0,1,1-.06-4.9h0l3,0h0a2.45,2.45,0,1,1,.07,4.9Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M374.3,1317.91l-3-.06a2.45,2.45,0,1,1,.1-4.9h0l3,.06h0a2.45,2.45,0,1,1-.09,4.9Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M364.23,1317.6l-3-.16a2.45,2.45,0,0,1,.27-4.89h0l3,.15h0a2.45,2.45,0,0,1-.26,4.89Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M354.16,1316.92l-3-.27a2.45,2.45,0,0,1,.45-4.87h0l2.95.27h0a2.44,2.44,0,1,1-.44,4.86Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M344.12,1315.87l-3-.39a2.44,2.44,0,1,1,.63-4.84h0l3,.39h0a2.44,2.44,0,0,1-.63,4.84Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M334.13,1314.43l-3-.5a2.43,2.43,0,1,1,.81-4.8h0l2.93.49h0a2.43,2.43,0,1,1-.81,4.8Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M324.21,1312.63l-3-.62a2.43,2.43,0,1,1,1-4.76h0l2.91.6h0a2.43,2.43,0,0,1-1,4.77Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M314.35,1310.46l-2.94-.72a2.43,2.43,0,1,1,1.16-4.72h0l2.88.71h0a2.43,2.43,0,0,1-1.15,4.72Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M304.59,1307.93l-2.91-.83a2.42,2.42,0,1,1,1.32-4.66h0l2.87.81h0a2.43,2.43,0,0,1-1.32,4.67Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M294.92,1305.06l-2.88-.93a2.42,2.42,0,1,1,1.49-4.61h0l2.83.91h0a2.43,2.43,0,0,1-1.49,4.62Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M285.36,1301.84l-2.84-1a2.42,2.42,0,1,1,1.64-4.55h0l2.8,1h0a2.42,2.42,0,0,1-1.64,4.56Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M275.92,1298.3l-2.81-1.12a2.42,2.42,0,0,1,1.8-4.49h0l2.76,1.11h0a2.41,2.41,0,1,1-1.8,4.48Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M266.61,1294.44l-2.77-1.22a2.41,2.41,0,0,1,2-4.41h0l2.72,1.19h0a2.41,2.41,0,0,1-1.94,4.42Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M257.43,1290.27l-2.72-1.31a2.41,2.41,0,1,1,2.09-4.34h0l2.68,1.29h0a2.41,2.41,0,0,1-2.09,4.35Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M248.4,1285.79l-2.68-1.4a2.4,2.4,0,0,1,2.23-4.26h0l2.64,1.37,0,0a2.4,2.4,0,1,1-2.23,4.26Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M239.52,1281l-2.62-1.48a2.4,2.4,0,0,1,2.36-4.19h0l2.59,1.46,0,0a2.4,2.4,0,0,1-2.36,4.18Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M230.81,1276l-2.58-1.57a2.4,2.4,0,0,1,2.49-4.1h0l2.54,1.55h0a2.4,2.4,0,1,1-2.49,4.1Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M222.26,1270.64l-2.53-1.65a2.4,2.4,0,0,1,2.62-4h0l2.49,1.62,0,0a2.39,2.39,0,1,1-2.61,4Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M213.89,1265l-2.49-1.73a2.39,2.39,0,0,1,2.74-3.92h0l2.44,1.7,0,0a2.39,2.39,0,1,1-2.73,3.92Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M205.69,1259.18l-2.43-1.81a2.38,2.38,0,1,1,2.85-3.82h0l2.39,1.78h0a2.39,2.39,0,1,1-2.85,3.83Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M197.67,1253.07l-2.36-1.88a2.38,2.38,0,1,1,3-3.73h0l2.33,1.85,0,0a2.38,2.38,0,1,1-3,3.73Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M189.85,1246.72l-2.3-2a2.38,2.38,0,0,1,3.08-3.64h0l2.28,1.93h0a2.38,2.38,0,0,1-3.07,3.64Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M182.24,1240.13l-2.25-2a2.38,2.38,0,0,1,3.18-3.54l0,0,2.21,2h0a2.38,2.38,0,1,1-3.18,3.54Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M174.82,1233.31l-2.18-2.09a2.37,2.37,0,0,1,3.28-3.43l0,0,2.15,2,0,0a2.38,2.38,0,1,1-3.29,3.43Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M167.62,1226.27l-2.12-2.15a2.37,2.37,0,1,1,3.38-3.33l0,0,2.09,2.12h0a2.37,2.37,0,1,1-3.38,3.33Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M160.63,1219l-2-2.22a2.37,2.37,0,0,1,3.48-3.22v0l2,2.18v0a2.37,2.37,0,1,1-3.48,3.22Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M153.87,1211.55l-2-2.27a2.36,2.36,0,1,1,3.56-3.11h0l1.95,2.25,0,0a2.37,2.37,0,0,1-3.57,3.11Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M147.34,1203.89l-1.92-2.34a2.36,2.36,0,0,1,3.66-3h0l1.89,2.31h0a2.36,2.36,0,1,1-3.65,3Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M141,1196l-1.84-2.4a2.36,2.36,0,0,1,3.74-2.87h0l1.82,2.36v0A2.36,2.36,0,0,1,141,1196Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M135,1188l-1.77-2.45a2.36,2.36,0,1,1,3.82-2.76v0l1.75,2.41v0A2.36,2.36,0,0,1,135,1188Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M129.18,1179.75l-1.69-2.51a2.35,2.35,0,0,1,3.9-2.63v0l1.67,2.46v0a2.35,2.35,0,1,1-3.89,2.64Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M123.64,1171.34l-1.61-2.56a2.35,2.35,0,1,1,4-2.5h0l1.59,2.52v0a2.35,2.35,0,0,1-4,2.51Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M118.36,1162.76l-1.54-2.6a2.35,2.35,0,0,1,4.05-2.38v0l1.51,2.56v0a2.34,2.34,0,0,1-4,2.38Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M113.35,1154l-1.45-2.65a2.34,2.34,0,0,1,4.1-2.24h0l1.43,2.62v0a2.34,2.34,0,1,1-4.1,2.24Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M108.63,1145.12l-1.37-2.7a2.33,2.33,0,0,1,4.15-2.1v0l1.35,2.66v0a2.33,2.33,0,1,1-4.15,2.1Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M104.19,1136.07l-1.27-2.74a2.31,2.31,0,1,1,4.19-1.95v0l1.26,2.69v0a2.32,2.32,0,1,1-4.2,2Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M100.05,1126.88l-1.18-2.78a2.3,2.3,0,0,1,4.24-1.8v0l1.17,2.73v0a2.31,2.31,0,0,1-4.25,1.82Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M96.22,1117.57l-1.09-2.82a2.29,2.29,0,1,1,4.28-1.65h0l1.07,2.77v0a2.3,2.3,0,0,1-4.28,1.66Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M92.7,1108.13l-1-2.86a2.29,2.29,0,0,1,4.32-1.5v0l1,2.81v0a2.29,2.29,0,1,1-4.32,1.51Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M89.5,1098.57l-.9-2.89a2.28,2.28,0,0,1,4.35-1.34h0l.89,2.85v0a2.28,2.28,0,0,1-4.35,1.36Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M86.63,1088.91l-.79-2.92a2.26,2.26,0,1,1,4.36-1.19v0l.79,2.87v0a2.27,2.27,0,1,1-4.37,1.2Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M84.1,1079.15l-.69-2.94a2.25,2.25,0,1,1,4.39-1v0l.69,2.89v0a2.26,2.26,0,0,1-4.39,1Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M81.92,1069.31l-.59-3a2.25,2.25,0,0,1,4.41-.87v0l.58,2.91v0a2.25,2.25,0,0,1-4.41.88Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M80.09,1059.4l-.47-3a2.23,2.23,0,1,1,4.41-.7v0l.48,2.93v0a2.24,2.24,0,0,1-4.42.71Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M78.63,1049.42l-.37-3a2.23,2.23,0,1,1,4.42-.54v0l.37,2.95v0a2.23,2.23,0,0,1-4.42.55Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M77.53,1039.4l-.25-3a2.21,2.21,0,1,1,4.41-.38v0l.26,3v0a2.21,2.21,0,0,1-4.41.39Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M76.82,1029.34l-.14-3a2.2,2.2,0,1,1,4.4-.2v0l.14,3v0a2.2,2.2,0,1,1-4.4.22Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M76.48,1019.27l0-3a2.2,2.2,0,1,1,4.39,0v0l0,3v0a2.2,2.2,0,1,1-4.39,0Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M76.53,1009.19l.09-3a2.18,2.18,0,1,1,4.36.13v0l-.08,3v0a2.19,2.19,0,1,1-4.37-.12Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M77,999.11l.21-3a2.18,2.18,0,1,1,4.34.3v0l-.19,3v0a2.18,2.18,0,0,1-4.35-.28Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M77.78,989.06l.32-3a2.17,2.17,0,0,1,4.31.46v0l-.31,3v0a2.17,2.17,0,0,1-4.31-.45Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M79,979.05l.43-3a2.15,2.15,0,1,1,4.26.62v0l-.42,2.94v0a2.16,2.16,0,1,1-4.27-.6Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M80.55,969.1l.54-3a2.14,2.14,0,0,1,4.22.76v0l-.52,2.93v0a2.14,2.14,0,1,1-4.22-.77Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M82.48,959.21l.65-3a2.13,2.13,0,0,1,4.17.91v0l-.63,2.91v0a2.13,2.13,0,1,1-4.17-.91Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M84.77,949.4l.76-2.93a2.12,2.12,0,0,1,4.11,1.06v0l-.73,2.88v0a2.13,2.13,0,0,1-4.12-1.06Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M87.41,939.67l.86-2.89a2.11,2.11,0,1,1,4,1.2h0l-.84,2.86v0a2.12,2.12,0,0,1-4.06-1.19Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M90.39,930.05l1-2.86a2.1,2.1,0,0,1,4,1.33v0l-.94,2.82v0a2.11,2.11,0,1,1-4-1.32Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M93.7,920.54l1.06-2.83a2.09,2.09,0,1,1,3.92,1.46v0l-1,2.79v0a2.1,2.1,0,1,1-3.93-1.46Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M97.34,911.15l1.15-2.8a2.08,2.08,0,1,1,3.85,1.59v0l-1.13,2.75v0a2.09,2.09,0,1,1-3.86-1.58Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M101.28,901.88l1.25-2.75a2.07,2.07,0,1,1,3.77,1.71h0l-1.22,2.72v0a2.08,2.08,0,0,1-3.79-1.7Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M105.54,892.76l1.33-2.71a2.06,2.06,0,0,1,3.7,1.82v0l-1.31,2.67v0a2.07,2.07,0,1,1-3.71-1.82Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M110.09,883.78l1.41-2.66a2.06,2.06,0,1,1,3.63,1.93h0l-1.4,2.63v0a2.06,2.06,0,0,1-3.63-1.93Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M114.92,875l1.51-2.62a2,2,0,1,1,3.53,2h0L118.48,877v0a2,2,0,0,1-3.55-2Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M120,866.29l1.59-2.57a2,2,0,0,1,3.46,2.14h0l-1.56,2.54v0A2,2,0,0,1,120,866.3Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M125.42,857.79l1.67-2.52a2,2,0,0,1,3.37,2.23v0L128.81,860h0a2,2,0,1,1-3.38-2.23Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M131.08,849.46l1.74-2.46a2,2,0,1,1,3.28,2.32h0l-1.71,2.44,0,0a2,2,0,0,1-3.29-2.33Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M137,841.31l1.82-2.4a2,2,0,1,1,3.19,2.41h0l-1.79,2.38v0a2,2,0,0,1-3.2-2.41Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M143.14,833.36,145,831a2,2,0,1,1,3.08,2.49h0l-1.86,2.32v0a2,2,0,1,1-3.1-2.49Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M149.54,825.6l2-2.29a2,2,0,0,1,3,2.55h0l-1.94,2.27v0a2,2,0,1,1-3-2.56Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M156.17,818l2-2.22a1.94,1.94,0,1,1,2.87,2.62h0l-2,2.21h0a2,2,0,0,1-2.89-2.62Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M163,810.68l2.1-2.17a1.93,1.93,0,0,1,2.77,2.68h0l-2.07,2.15h0a1.93,1.93,0,1,1-2.78-2.68Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M170.11,803.53l2.17-2.1a1.91,1.91,0,0,1,2.66,2.74h0l-2.13,2.08,0,0a1.91,1.91,0,0,1-2.67-2.74Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M177.4,796.61l2.23-2a1.89,1.89,0,1,1,2.55,2.79h0l-2.2,2h0a1.9,1.9,0,0,1-2.57-2.79Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M184.9,789.9l2.29-2a1.87,1.87,0,0,1,2.44,2.84h0l-2.26,2h0a1.88,1.88,0,0,1-2.46-2.84Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M192.6,783.43l2.35-1.89a1.86,1.86,0,1,1,2.33,2.89h0L195,786.32h0a1.86,1.86,0,0,1-2.35-2.89Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M200.5,777.2l2.4-1.82a1.84,1.84,0,0,1,2.22,2.93h0l-2.37,1.81h0a1.84,1.84,0,1,1-2.24-2.93Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M208.58,771.22l2.46-1.75a1.82,1.82,0,0,1,2.1,3h0l-2.43,1.74h0a1.83,1.83,0,0,1-2.13-3Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M216.84,765.48l2.51-1.67a1.81,1.81,0,0,1,2,3h0l-2.48,1.66h0a1.81,1.81,0,0,1-2-3Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M225.28,760l2.56-1.59a1.78,1.78,0,1,1,1.88,3h0L227.18,763h0a1.79,1.79,0,1,1-1.9-3Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M233.88,754.81l2.61-1.51a1.77,1.77,0,1,1,1.77,3.06h0l-2.58,1.5h0a1.77,1.77,0,0,1-1.78-3.06Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M242.65,749.88l2.66-1.42a1.75,1.75,0,0,1,1.65,3.08h0L244.32,753h0a1.76,1.76,0,0,1-1.67-3.09Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M251.57,745.23l2.71-1.33a1.73,1.73,0,1,1,1.53,3.1h0l-2.67,1.33h0a1.73,1.73,0,1,1-1.55-3.1Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M260.64,740.88l2.75-1.24a1.71,1.71,0,1,1,1.41,3.11h0L262.08,744h0a1.73,1.73,0,0,1-2.28-.85,1.71,1.71,0,0,1,.85-2.27Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M269.85,736.84l2.78-1.16a1.69,1.69,0,0,1,1.3,3.13h0L271.17,740h0a1.7,1.7,0,0,1-1.31-3.13Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M279.18,733.1,282,732a1.68,1.68,0,1,1,1.18,3.14h0l-2.79,1.06h0a1.68,1.68,0,1,1-1.2-3.14Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M288.64,729.68l2.86-1a1.66,1.66,0,1,1,1.05,3.14h0l-2.82,1h0a1.66,1.66,0,1,1-1.07-3.15Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M298.21,726.59l2.89-.86a1.64,1.64,0,1,1,.94,3.14h0l-2.85.87h0a1.65,1.65,0,0,1-.95-3.15Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M307.88,723.84l2.92-.76a1.62,1.62,0,1,1,.82,3.13h0l-2.88.76h0a1.62,1.62,0,0,1-.83-3.14Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M317.64,721.43l2.95-.66a1.6,1.6,0,0,1,.7,3.13h0l-2.91.65h0a1.61,1.61,0,1,1-.71-3.14Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M327.49,719.37l3-.55a1.59,1.59,0,0,1,.57,3.12h0l-2.93.56h0a1.59,1.59,0,1,1-.59-3.13Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M337.4,717.68l3-.44a1.57,1.57,0,1,1,.45,3.1h0l-2.95.44h0a1.57,1.57,0,0,1-.46-3.11Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M347.37,716.35l3-.33a1.56,1.56,0,0,1,1.71,1.38,1.54,1.54,0,0,1-1.37,1.7h0l-3,.33h0a1.55,1.55,0,0,1-.34-3.09Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M357.39,715.4l3-.21a1.53,1.53,0,1,1,.21,3h0l-3,.22h0a1.53,1.53,0,1,1-.23-3.06Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M367.43,714.82l3-.09a1.51,1.51,0,1,1,.1,3h0l-3,.11h0a1.52,1.52,0,0,1-.11-3Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1721.38,1076.46l-3,.26h0a1.24,1.24,0,1,1-.22-2.47h0l3-.24a1.23,1.23,0,0,1,.2,2.45Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1711.48,1077.46l-3,.37h0a1.28,1.28,0,0,1-.32-2.53h0l3-.36a1.26,1.26,0,0,1,.3,2.51Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1701.61,1078.81l-3,.46h0a1.31,1.31,0,0,1-.4-2.59h0l3-.44a1.3,1.3,0,0,1,.39,2.57Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1691.77,1080.41l-3,.52h0a1.35,1.35,0,0,1-.46-2.66h0l3-.5a1.33,1.33,0,0,1,.45,2.63Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1681.94,1082.19l-2.94.55a1.38,1.38,0,1,1-.52-2.72h0l3-.53a1.37,1.37,0,0,1,.49,2.7Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1672.12,1084l-2.95.55a1.42,1.42,0,1,1-.53-2.78h0l2.95-.53a1.4,1.4,0,0,1,.51,2.76Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1662.27,1085.85l-3,.53a1.45,1.45,0,0,1-.51-2.86h0l3-.51h0a1.44,1.44,0,0,1,.49,2.84Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1652.39,1087.55l-3,.47a1.48,1.48,0,1,1-.47-2.93h0l3-.44h0a1.48,1.48,0,0,1,.45,2.92Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1642.46,1089l-3,.38a1.52,1.52,0,0,1-.39-3h0l3-.36h0a1.51,1.51,0,0,1,.38,3Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1632.47,1090.2l-3,.27a1.56,1.56,0,1,1-.28-3.1h0l3-.25h0a1.55,1.55,0,0,1,.26,3.08Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1622.43,1091l-3,.12a1.59,1.59,0,0,1-.14-3.18h0l3-.1h0a1.58,1.58,0,0,1,.12,3.16Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1612.34,1091.16l-3-.06a1.62,1.62,0,1,1,.06-3.23h0l3,.06h0a1.62,1.62,0,1,1-.07,3.23Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1602.25,1090.73l-3-.27a1.63,1.63,0,0,1,.29-3.25h0l3,.27h0a1.63,1.63,0,0,1-.29,3.24Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1592.19,1089.57l-3-.49a1.65,1.65,0,0,1,.54-3.25h0l2.92.49h0a1.64,1.64,0,0,1-.54,3.23Z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1582.25,1087.67l-3-.71a1.66,1.66,0,1,1,.78-3.22h0l2.88.7h0a1.65,1.65,0,1,1-.78,3.21Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1572.48,1085.05l-2.89-.92a1.67,1.67,0,0,1,1-3.18h0l2.82.91h0a1.67,1.67,0,0,1-1,3.17Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1562.93,1081.74l-2.82-1.12a1.68,1.68,0,0,1,1.24-3.12h0l2.75,1.11h0a1.67,1.67,0,0,1-1.24,3.11Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1553.62,1077.77l-2.73-1.31a1.69,1.69,0,1,1,1.46-3h0l0,0,2.67,1.29h0a1.69,1.69,0,0,1-1.47,3Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1544.61,1073.17l-2.64-1.5a1.7,1.7,0,1,1,1.68-3h0l0,0,2.57,1.47,0,0a1.7,1.7,0,1,1-1.68,3Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1535.94,1068l-2.54-1.67a1.72,1.72,0,0,1,1.9-2.87h0l0,0,2.47,1.64,0,0a1.71,1.71,0,1,1-1.89,2.85Z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1527.64,1062.17l-2.42-1.84a1.73,1.73,0,1,1,2.11-2.75h0l0,0,2.35,1.81,0,0a1.73,1.73,0,0,1,.31,2.42A1.71,1.71,0,0,1,1527.64,1062.17Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1519.75,1055.83l-2.28-2a1.74,1.74,0,1,1,2.3-2.61h0l0,0,2.22,2,0,0a1.74,1.74,0,0,1-2.3,2.61Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1512.32,1049l-2.13-2.16a1.75,1.75,0,1,1,2.49-2.46h0l0,0,2.08,2.11,0,0a1.75,1.75,0,0,1-2.49,2.45Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1505.39,1041.57l-2-2.31a1.76,1.76,0,0,1,2.68-2.29h0l0,0,1.92,2.26,0,0a1.76,1.76,0,0,1-2.68,2.28Z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1499,1033.72l-1.81-2.45a1.78,1.78,0,0,1,2.86-2.11h0l0,0,1.75,2.38,0,0a1.77,1.77,0,0,1-2.85,2.1Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1493.21,1025.42l-1.62-2.58a1.79,1.79,0,0,1,3-1.9h0l0,0,1.56,2.5,0,0a1.79,1.79,0,0,1-3,1.9Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1488.05,1016.7l-1.42-2.7a1.8,1.8,0,0,1,3.18-1.68h0l0,0,1.38,2.63,0,0a1.8,1.8,0,0,1-3.18,1.68Z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1483.55,1007.61l-1.21-2.79a1.8,1.8,0,0,1,.94-2.38,1.82,1.82,0,0,1,2.39.93h0v0l1.18,2.71v0a1.81,1.81,0,1,1-3.32,1.44Z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1479.75,998.22l-1-2.86a1.82,1.82,0,1,1,3.44-1.21h0l0,0,1,2.79v0a1.82,1.82,0,1,1-3.44,1.2Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1476.64,988.58l-.79-2.93a1.83,1.83,0,0,1,3.54-1h0v0l.77,2.86v0a1.83,1.83,0,1,1-3.54,1Z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1474.23,978.75l-.59-3a1.85,1.85,0,0,1,3.63-.72h0v0l.57,2.9v0a1.84,1.84,0,1,1-3.62.71Z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1472.5,968.77l-.38-3a1.86,1.86,0,1,1,3.69-.47h0v0l.37,2.94v0a1.86,1.86,0,0,1-3.69.46Z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1471.47,958.69l-.17-3a1.87,1.87,0,1,1,3.74-.22h0v0l.16,3v0a1.87,1.87,0,0,1-3.74.21Z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1471.13,948.57l0-3a1.89,1.89,0,1,1,3.78,0h0v0l0,3v0a1.89,1.89,0,0,1-3.77,0Z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1471.48,938.45l.24-3a1.9,1.9,0,0,1,3.79.3h0v0l-.24,3v0a1.9,1.9,0,0,1-3.78-.3Z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1472.53,928.36l.45-3a1.91,1.91,0,1,1,3.78.56h0v0l-.44,2.93v0a1.91,1.91,0,1,1-3.77-.57Z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1474.27,918.38l.66-3a1.92,1.92,0,0,1,3.75.83h0v0l-.65,2.88v0a1.92,1.92,0,1,1-3.74-.83Z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1476.71,908.54l.86-2.91a1.93,1.93,0,0,1,3.71,1.1h0v0l-.85,2.83v0a1.93,1.93,0,0,1-3.7-1.11Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1479.84,898.91l1.07-2.85a2,2,0,0,1,3.65,1.38h0v0l-1,2.76,0,0a1.94,1.94,0,1,1-3.63-1.37Z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1483.67,889.52l1.28-2.76a2,2,0,0,1,3.55,1.65h0l0,0-1.25,2.67,0,0a2,2,0,0,1-3.54-1.65Z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1488.19,880.44l1.48-2.66a2,2,0,0,1,3.44,1.93h0l0,0-1.45,2.58,0,0a2,2,0,0,1-3.43-1.92Z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1493.34,871.71l1.65-2.54a2,2,0,1,1,3.33,2.16h0l0,0-1.61,2.48,0,0a2,2,0,1,1-3.31-2.16Z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1499,863.35l1.8-2.44a2,2,0,0,1,3.21,2.38h0l0,0-1.78,2.38,0,0a2,2,0,0,1-3.19-2.38Z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1505.23,855.36l1.94-2.33a2,2,0,0,1,3.06,2.56l0,0-1.9,2.28,0,0a2,2,0,1,1-3.07-2.55Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1511.85,847.73l2.06-2.22a2,2,0,1,1,2.9,2.69h0l-2,2.19,0,0a2,2,0,1,1-2.91-2.69Z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1518.82,840.44l2.15-2.12a2,2,0,1,1,2.76,2.79h0l-2.11,2.1,0,0a2,2,0,0,1-2.77-2.8Z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1526.08,833.46l2.23-2a2,2,0,0,1,2.64,2.88h0l-2.19,2h0a2,2,0,0,1-2.65-2.88Z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1533.59,826.75l2.29-2a1.94,1.94,0,1,1,2.52,2.94h0l-2.26,1.94v0a1.95,1.95,0,0,1-2.54-3Z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1541.28,820.28l2.33-1.9a1.93,1.93,0,0,1,2.43,3h0l-2.31,1.89h0a1.93,1.93,0,0,1-2.45-3Z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1549.12,814l2.37-1.86a1.92,1.92,0,0,1,2.36,3h0l-2.36,1.84h0a1.92,1.92,0,1,1-2.37-3Z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1557.07,807.89l2.4-1.81a1.9,1.9,0,0,1,2.29,3h0l-2.39,1.81h0a1.9,1.9,0,1,1-2.3-3Z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1565.1,801.89l2.42-1.79a1.89,1.89,0,0,1,2.24,3l-2.41,1.78a1.89,1.89,0,1,1-2.26-3Z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1573.17,796l2.43-1.76a1.87,1.87,0,0,1,2.21,3l-2.42,1.78a1.88,1.88,0,0,1-2.23-3Z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1581.26,790.08l2.42-1.77a1.86,1.86,0,0,1,2.2,3l-2.43,1.77a1.86,1.86,0,0,1-2.2-3Z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1589.33,784.19l2.41-1.78h0a1.85,1.85,0,1,1,2.2,3l-2.42,1.79a1.85,1.85,0,0,1-2.2-3h0Z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1597.33,778.23l2.38-1.81h0a1.83,1.83,0,1,1,2.22,2.92l-2.39,1.82a1.84,1.84,0,1,1-2.23-2.92h0Z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1605.23,772.16l2.35-1.85h0a1.82,1.82,0,0,1,2.26,2.86l-2.36,1.87a1.83,1.83,0,1,1-2.27-2.86h0Z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1613,765.93l2.3-1.9h0a1.81,1.81,0,0,1,2.31,2.79l-2.32,1.92a1.81,1.81,0,0,1-2.32-2.79h0Z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1620.62,759.52l2.25-2h0a1.79,1.79,0,0,1,2.36,2.7l-2.26,2a1.8,1.8,0,1,1-2.38-2.7h0Z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1628,752.9l2.18-2h0a1.78,1.78,0,0,1,2.44,2.6l-2.21,2.06a1.78,1.78,0,1,1-2.44-2.6h0Z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1635.22,746l2.1-2.11,0,0a1.77,1.77,0,0,1,2.51,2.5l-2.13,2.14a1.77,1.77,0,0,1-2.52-2.49h0Z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1642.12,738.91l2-2.2,0,0a1.76,1.76,0,1,1,2.59,2.37l-2,2.23a1.76,1.76,0,0,1-2.61-2.36h0Z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1648.69,731.48l1.89-2.29,0,0a1.74,1.74,0,0,1,2.69,2.21l-1.93,2.34a1.74,1.74,0,1,1-2.69-2.22h0Z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1654.86,723.73l1.76-2.39,0,0a1.73,1.73,0,0,1,2.79,2.05l-1.8,2.45a1.73,1.73,0,0,1-2.79-2h0Z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1660.57,715.64l1.6-2.48,0,0a1.72,1.72,0,0,1,2.89,1.86l-1.64,2.54a1.72,1.72,0,1,1-2.89-1.86h0Z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1665.73,707.22l1.44-2.59v0a1.7,1.7,0,1,1,3,1.64l-1.46,2.66a1.71,1.71,0,1,1-3-1.64h0Z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1670.29,698.46l1.23-2.69,0,0a1.69,1.69,0,0,1,3.07,1.4l-1.26,2.77a1.69,1.69,0,1,1-3.08-1.41h0Z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1674.15,689.39l1-2.78v0a1.68,1.68,0,0,1,3.15,1.15l-1,2.85a1.68,1.68,0,0,1-3.16-1.14h0Z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1677.26,680c.28-.95.51-1.9.77-2.85v-.05a1.66,1.66,0,0,1,3.21.86c-.26,1-.5,2-.78,3v0a1.67,1.67,0,0,1-3.2-.93Z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1679.41,670.47l.42-2.91v0a1.65,1.65,0,1,1,3.27.47l-.43,3a1.66,1.66,0,0,1-3.28-.46h0Z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1680.44,660.72l.1-3v0a1.64,1.64,0,0,1,3.27.1l-.09,3a1.64,1.64,0,1,1-3.28-.1h0Z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1680.4,650.89l-.21-2.94v-.05a1.62,1.62,0,0,1,3.24-.24l.22,3.05a1.62,1.62,0,1,1-3.24.24h0Z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1679.36,641.11l-.5-2.9v-.05a1.6,1.6,0,0,1,3.15-.55l.54,3a1.61,1.61,0,1,1-3.17.56h0Z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1677.36,631.48l-.79-2.85v0a1.56,1.56,0,0,1,3-.84l.83,2.93a1.57,1.57,0,0,1-3,.86h0Z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1674.41,622.09l-1.07-2.75,0,0a1.53,1.53,0,0,1,2.84-1.12l1.12,2.83a1.53,1.53,0,1,1-2.85,1.14h0Z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1670.51,613.06l-1.36-2.62,0-.05a1.48,1.48,0,0,1,.64-2,1.5,1.5,0,0,1,2,.63l1.42,2.7a1.5,1.5,0,0,1-2.66,1.39h0Z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1665.66,604.51l-1.65-2.45,0,0a1.45,1.45,0,0,1,2.4-1.62l1.72,2.52a1.46,1.46,0,0,1-2.41,1.65h0Z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1659.84,596.59l-1.93-2.22,0,0a1.41,1.41,0,0,1,2.12-1.86l2,2.29a1.42,1.42,0,1,1-2.13,1.88h0Z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1653.07,589.5l-2.22-1.93,0,0a1.37,1.37,0,0,1,1.79-2.07l2.33,2a1.39,1.39,0,0,1-1.81,2.1h0Z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1645.37,583.48l-2.49-1.57-.05,0a1.34,1.34,0,0,1,1.41-2.27l2.61,1.62a1.35,1.35,0,0,1-1.42,2.29h0Z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1636.82,578.75l-2.71-1.12-.06,0a1.3,1.3,0,0,1-.7-1.69,1.31,1.31,0,0,1,1.69-.71l2.84,1.16a1.31,1.31,0,0,1-1,2.42h0Z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1627.59,575.56l-2.86-.64h-.06a1.26,1.26,0,0,1,.53-2.46l3,.64a1.28,1.28,0,0,1,1,1.51,1.27,1.27,0,0,1-1.51,1h-.08Z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1618,574l-.25,0h0a1.23,1.23,0,0,1,.16-2.46l.26,0A1.23,1.23,0,1,1,1618,574h0Z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1697.17,1043.25l-3.05-.15a1.53,1.53,0,0,1,.15-3.06h.07l2.94.18h.06a1.51,1.51,0,0,1-.17,3Z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1687,1042.35l-3-.49a1.59,1.59,0,1,1,.51-3.13h.06l2.91.5h0a1.57,1.57,0,0,1-.52,3.1Z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1677.07,1040.35l-2.94-.8a1.64,1.64,0,0,1,.87-3.17h0l0,0,2.84.81h0a1.62,1.62,0,0,1-.87,3.13Z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1667.37,1037.32l-2.84-1.09a1.7,1.7,0,0,1,1.22-3.17h0l0,0,2.74,1.09,0,0a1.68,1.68,0,0,1-1.23,3.12Z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1658,1033.33l-2.72-1.37a1.75,1.75,0,1,1,1.58-3.13h0l0,0,2.62,1.36,0,0a1.73,1.73,0,0,1-1.59,3.08Z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1649.11,1028.42l-2.57-1.64a1.77,1.77,0,1,1,1.91-3h0l0,0,2.48,1.6,0,0a1.77,1.77,0,0,1-1.91,3Z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1640.73,1022.66l-2.4-1.89a1.79,1.79,0,0,1,2.21-2.82h0l0,0,2.31,1.83,0,0a1.79,1.79,0,0,1-2.21,2.81Z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1633,1016.11l-2.22-2.11a1.81,1.81,0,1,1,2.51-2.62h0l0,0,2.13,2.05,0,0a1.81,1.81,0,0,1,0,2.56A1.79,1.79,0,0,1,1633,1016.11Z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1625.83,1008.84l-2-2.32a1.83,1.83,0,0,1,2.78-2.39h0l0,0,1.91,2.24,0,0a1.83,1.83,0,0,1-2.77,2.38Z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1619.46,1000.89l-1.75-2.51a1.85,1.85,0,1,1,3-2.12h0l0,.05,1.67,2.41,0,0a1.85,1.85,0,0,1-3,2.11Z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1613.94,992.33l-1.48-2.68a1.87,1.87,0,0,1,3.28-1.81h0l0,0,1.41,2.58,0,0a1.87,1.87,0,0,1-3.27,1.8Z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1609.35,983.22l-1.18-2.82a1.89,1.89,0,1,1,3.48-1.46h0l0,0,1.12,2.72,0,.06a1.88,1.88,0,0,1-3.48,1.44Z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1605.78,973.66l-.86-2.94a1.91,1.91,0,0,1,3.67-1.07h0l0,.06.81,2.83,0,.06a1.91,1.91,0,0,1-3.66,1.06Z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1603.3,963.76l-.54-3a1.93,1.93,0,0,1,3.8-.67h0v.06l.5,2.89v.06a1.93,1.93,0,0,1-1.56,2.23A1.91,1.91,0,0,1,1603.3,963.76Z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1601.88,953.66l-.22-3a1.95,1.95,0,0,1,3.89-.27h0v.06l.2,2.93v.06a1.94,1.94,0,0,1-3.87.27Z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1601.52,943.48l.09-3.06a2,2,0,0,1,3.93.12h0v.05l-.1,2.94v.06a2,2,0,0,1-2,1.89A1.94,1.94,0,0,1,1601.52,943.48Z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1602.17,933.31l.39-3a2,2,0,0,1,3.94.51h0v.05l-.39,2.92v.06a2,2,0,0,1-3.93-.51Z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1603.81,923.25l.69-3a2,2,0,1,1,3.89.9v.05l-.66,2.87v.06a2,2,0,1,1-3.9-.9Z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1606.45,913.41l1-2.9a2,2,0,1,1,3.76,1.26v.05l-.93,2.79,0,.06a2,2,0,0,1-3.77-1.26Z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1610,903.86l1.26-2.79a2,2,0,0,1,3.59,1.61l0,.05-1.2,2.69,0,.06a2,2,0,0,1-3.61-1.61Z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1614.52,894.71l1.52-2.66a2,2,0,0,1,3.4,2l0,0-1.46,2.56,0,0a2,2,0,1,1-3.4-1.95Z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1619.9,886.05l1.79-2.48a1.95,1.95,0,0,1,3.16,2.27l0,0-1.71,2.39,0,.05a1.95,1.95,0,1,1-3.17-2.27Z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1626.16,878l2-2.28a1.93,1.93,0,1,1,2.88,2.57l0,0-2,2.2,0,0a1.93,1.93,0,1,1-2.89-2.57Z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1633.24,870.66l2.28-2a1.92,1.92,0,0,1,2.57,2.86l0,0-2.18,2,0,0a1.93,1.93,0,0,1-2.58-2.86Z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1641.06,864.12l2.46-1.8a1.91,1.91,0,1,1,2.26,3.07l0,0-2.37,1.75,0,0a1.91,1.91,0,0,1-2.27-3.07Z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1649.44,858.37l2.6-1.59a1.89,1.89,0,1,1,2,3.23l0,0-2.52,1.54,0,0a1.89,1.89,0,1,1-2-3.23Z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1658.23,853.32l2.71-1.39a1.88,1.88,0,0,1,1.72,3.35h0l-2.64,1.36,0,0a1.89,1.89,0,1,1-1.73-3.35Z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1667.33,848.9l2.77-1.23a1.87,1.87,0,1,1,1.51,3.42h0l-2.72,1.21h0a1.87,1.87,0,1,1-1.51-3.42Z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1676.64,845l2.82-1.09a1.86,1.86,0,0,1,1.33,3.47h0l-2.77,1.08h0a1.86,1.86,0,1,1-1.35-3.47Z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1686.08,841.5l2.85-1a1.84,1.84,0,0,1,1.2,3.48h0l-2.82,1h0a1.84,1.84,0,0,1-1.22-3.48Z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1695.6,838.31l2.87-.92a1.83,1.83,0,1,1,1.11,3.49h0l-2.85.91h0a1.83,1.83,0,0,1-1.12-3.49Z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1705.18,835.32l2.87-.87a1.81,1.81,0,1,1,1.06,3.47l-2.87.88a1.82,1.82,0,0,1-1.07-3.48Z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1714.76,832.43l2.87-.86a1.82,1.82,0,0,1,2.25,1.21,1.79,1.79,0,0,1-1.21,2.24l-2.87.87a1.81,1.81,0,1,1-1-3.46Z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1724.33,829.55l2.86-.88h0a1.79,1.79,0,0,1,1,3.42l-2.87.89a1.8,1.8,0,1,1-1.06-3.43h0Z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1733.85,826.58l2.84-.93h0a1.78,1.78,0,1,1,1.1,3.38l-2.86.94a1.78,1.78,0,0,1-1.11-3.39h0Z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1743.28,823.41l2.81-1h0a1.76,1.76,0,0,1,1.19,3.32l-2.84,1a1.77,1.77,0,1,1-1.2-3.32h0Z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1752.59,819.94l2.76-1.11h0a1.74,1.74,0,0,1,1.31,3.23l-2.79,1.15a1.75,1.75,0,0,1-1.34-3.24h0Z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1761.72,816.08l2.69-1.25,0,0a1.7,1.7,0,0,1,1.46,3.08l-2.74,1.31a1.72,1.72,0,0,1-1.47-3.1h0Z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1770.57,811.69l2.59-1.44h0a1.66,1.66,0,0,1,1.63,2.9l-2.65,1.5a1.68,1.68,0,1,1-1.65-2.92h0Z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1779.06,806.66l2.45-1.65,0,0a1.63,1.63,0,0,1,1.83,2.69l-2.51,1.72a1.64,1.64,0,0,1-1.85-2.71h0Z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1787,800.9l2.26-1.89,0,0a1.59,1.59,0,0,1,2,2.44l-2.33,2a1.6,1.6,0,1,1-2.06-2.45h0Z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1794.34,794.34l2-2.12,0,0a1.55,1.55,0,0,1,2.24,2.14l-2.1,2.22a1.56,1.56,0,1,1-2.27-2.15h0Z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1800.84,787l1.78-2.35,0,0a1.52,1.52,0,0,1,2.43,1.82l-1.83,2.45a1.53,1.53,0,0,1-2.45-1.82h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2BProject3);
export default __webpack_public_path__ + "static/media/b2b_project_3.14e721494295e53a744e147ec8e2a49a.svg";
export { ForwardRef as ReactComponent };